/** Auto-generated English → admin.ui.* keys — do not edit by hand.
 * Regenerate: node frontend/_generate_ui_catalog.cjs
 */
export const ADMIN_PANEL_UI_MAP: Record<string, string> = {
  "— Any / All —": "admin.ui.any_all",
  "— No options —": "admin.ui.no_options",
  "— None —": "admin.ui.none",
  "— Select —": "admin.ui.select",
  "— Select merchant —": "admin.ui.select_merchant",
  "— Select plan —": "admin.ui.select_plan",
  "— Select template —": "admin.ui.select_template",
  "— Select zone —": "admin.ui.select_zone",
  "+91xxxxxxxxxx": "admin.ui.91xxxxxxxxxx",
  "1. Consultation Setup": "admin.ui.1_consultation_setup",
  "1. Event Booking": "admin.ui.1_event_booking",
  "1. Fleet & Branch": "admin.ui.1_fleet_branch",
  "1. Fleet & Depots": "admin.ui.1_fleet_depots",
  "1. Geography": "admin.ui.1_geography",
  "1. Home Banners": "admin.ui.1_home_banners",
  "1. Outstation Vehicles": "admin.ui.1_outstation_vehicles",
  "1. Promos & Coupons": "admin.ui.1_promos_coupons",
  "1. Restaurant & Branch": "admin.ui.1_restaurant_branch",
  "1. Service Catalog": "admin.ui.1_service_catalog",
  "1. Store & Types": "admin.ui.1_store_types",
  "17 Food Add masters → 6-tab wizard. Swiggy-like order pipeline with OTP delivery.": "admin.ui.17_food_add_masters_6_tab_wizard_swiggy_like_order_pipeline_with_otp_delivery",
  "2. Classification": "admin.ui.2_classification",
  "2. Locale & Currency": "admin.ui.2_locale_currency",
  "2. Outstation Pricing": "admin.ui.2_outstation_pricing",
  "2. Pricing": "admin.ui.2_pricing",
  "2. Rental Vehicles": "admin.ui.2_rental_vehicles",
  "2. Vehicle Taxonomy": "admin.ui.2_vehicle_taxonomy",
  "2. Warehouses & Variants": "admin.ui.2_warehouses_variants",
  "3. Attributes & Variants": "admin.ui.3_attributes_variants",
  "3. Availability": "admin.ui.3_availability",
  "3. Images & Availability": "admin.ui.3_images_availability",
  "3. Operations": "admin.ui.3_operations",
  "3. Rental Packages": "admin.ui.3_rental_packages",
  "3. Ride Attributes": "admin.ui.3_ride_attributes",
  "30-day service trends": "admin.ui.30_day_service_trends",
  "4-hour live pulse": "admin.ui.4_hour_live_pulse",
  "4-tab Grocery Add wizard — masters drive category, brand, variant, tax, and images.": "admin.ui.4_tab_grocery_add_wizard_masters_drive_category_brand_variant_tax_and_images",
  "4. Addons": "admin.ui.4_addons",
  "4. Availability & Media": "admin.ui.4_availability_media",
  "4. Grocery Add": "admin.ui.4_grocery_add",
  "4. Payments": "admin.ui.4_payments",
  "5. Delivery Operations": "admin.ui.5_delivery_operations",
  "5. Tax, Unit, Kitchen": "admin.ui.5_tax_unit_kitchen",
  "6-tab Food Add flow — variants, addons, tax, availability. No inventory or discounts.": "admin.ui.6_tab_food_add_flow_variants_addons_tax_availability_no_inventory_or_discounts",
  "6-tab wizard — all 12 grocery masters drive category, supply, availability, and images.": "admin.ui.6_tab_wizard_all_12_grocery_masters_drive_category_supply_availability_and_image",
  "6-tab wizard — catalog only": "admin.ui.6_tab_wizard_catalog_only",
  "6-tab wizard — full catalog flow": "admin.ui.6_tab_wizard_full_catalog_flow",
  "6. Availability & Images": "admin.ui.6_availability_images",
  "7-tab professional flow — only food-catalog masters (no inventory, recipe, or discount)": "admin.ui.7_tab_professional_flow_only_food_catalog_masters_no_inventory_recipe_or_discoun",
  "7. Admin Operations": "admin.ui.7_admin_operations",
  "7. Food Add": "admin.ui.7_food_add",
  "Accept / Reject": "admin.ui.accept_reject",
  "Accept incoming restaurant orders, mark ready, and track delivery": "admin.ui.accept_incoming_restaurant_orders_mark_ready_and_track_delivery",
  "Accept Order": "admin.ui.accept_order",
  "Accept orders, track kitchen-to-delivery workflow, and collect ratings.": "admin.ui.accept_orders_track_kitchen_to_delivery_workflow_and_collect_ratings",
  "Accept Ride": "admin.ui.accept_ride",
  "Accept store orders, pack items, mark ready, and track delivery": "admin.ui.accept_store_orders_pack_items_mark_ready_and_track_delivery",
  "Accepted": "admin.ui.accepted",
  "Access & Roles": "admin.ui.access_roles",
  "Account Code": "admin.ui.account_code",
  "Accounts": "admin.ui.accounts",
  "Acknowledged": "admin.ui.acknowledged",
  "Action": "admin.ui.action",
  "Action items": "admin.ui.action_items",
  "Actions": "admin.ui.actions",
  "Activate": "admin.ui.activate",
  "Active": "admin.ui.active",
  "Active — available for purchase": "admin.ui.active_available_for_purchase",
  "Active — can be assigned to tenants": "admin.ui.active_can_be_assigned_to_tenants",
  "Active Alerts": "admin.ui.active_alerts",
  "Active food orders": "admin.ui.active_food_orders",
  "Active grocery orders": "admin.ui.active_grocery_orders",
  "Active incentives": "admin.ui.active_incentives",
  "Active Listing": "admin.ui.active_listing",
  "Active Rides": "admin.ui.active_rides",
  "Active Subs": "admin.ui.active_subs",
  "Add": "admin.ui.add",
  "Add (+)": "admin.ui.add_2",
  "Add category": "admin.ui.add_category",
  "Add customer": "admin.ui.add_customer",
  "Add hour/km packages with per-vehicle pricing for all transport rental services from one screen.": "admin.ui.add_hour_km_packages_with_per_vehicle_pricing_for_all_transport_rental_services_",
  "Add inclusion": "admin.ui.add_inclusion",
  "Add package": "admin.ui.add_package",
  "Add tier": "admin.ui.add_tier",
  "Add to cart": "admin.ui.add_to_cart",
  "Add to Cart": "admin.ui.add_to_cart_2",
  "Addon": "admin.ui.addon",
  "Addon Group": "admin.ui.addon_group",
  "Addon Groups": "admin.ui.addon_groups",
  "Addon name": "admin.ui.addon_name",
  "Address": "admin.ui.address",
  "Address / Notes": "admin.ui.address_notes",
  "Address & Notes": "admin.ui.address_notes_2",
  "Address Fields": "admin.ui.address_fields",
  "Admin": "admin.ui.admin",
  "Admin & Staff": "admin.ui.admin_staff",
  "Admin & Staff — Full Function Reference": "admin.ui.admin_staff_full_function_reference",
  "Admin Commission Type": "admin.ui.admin_commission_type",
  "Admin Commission Value": "admin.ui.admin_commission_value",
  "Admin email": "admin.ui.admin_email",
  "Admin Email": "admin.ui.admin_email_2",
  "Admin first name": "admin.ui.admin_first_name",
  "Admin functions — not in Service Add wizard": "admin.ui.admin_functions_not_in_service_add_wizard",
  "Admin functions — store, slot, and dispatch controls": "admin.ui.admin_functions_store_slot_and_dispatch_controls",
  "Admin functions — Swiggy-like platform controls": "admin.ui.admin_functions_swiggy_like_platform_controls",
  "Admin Hub Tabs — Food / Delivery Service": "admin.ui.admin_hub_tabs_food_delivery_service",
  "Admin Hub Tabs — Transport Service": "admin.ui.admin_hub_tabs_transport_service",
  "Admin last name": "admin.ui.admin_last_name",
  "Admin Login URL": "admin.ui.admin_login_url",
  "Admin Panel": "admin.ui.admin_panel",
  "Admin password": "admin.ui.admin_password",
  "Admin Password": "admin.ui.admin_password_2",
  "Admin phone": "admin.ui.admin_phone",
  "Admin user": "admin.ui.admin_user",
  "Admin verification required": "admin.ui.admin_verification_required",
  "Administration": "admin.ui.administration",
  "Aggregate": "admin.ui.aggregate",
  "All": "admin.ui.all",
  "All agents": "admin.ui.all_agents",
  "All apps": "admin.ui.all_apps",
  "All categories": "admin.ui.all_categories",
  "All History": "admin.ui.all_history",
  "All hubs": "admin.ui.all_hubs",
  "All modules": "admin.ui.all_modules",
  "All on-demand services": "admin.ui.all_on_demand_services",
  "All outstation services": "admin.ui.all_outstation_services",
  "All partner types": "admin.ui.all_partner_types",
  "All payments": "admin.ui.all_payments",
  "All pending": "admin.ui.all_pending",
  "All rental services": "admin.ui.all_rental_services",
  "All Rides": "admin.ui.all_rides",
  "All services": "admin.ui.all_services",
  "All Services": "admin.ui.all_services_2",
  "All statuses": "admin.ui.all_statuses",
  "All store operations — food, grocery, menu, inventory, and payouts": "admin.ui.all_store_operations_food_grocery_menu_inventory_and_payouts",
  "All stores": "admin.ui.all_stores",
  "All sub": "admin.ui.all_sub",
  "All tenants": "admin.ui.all_tenants",
  "All tickets": "admin.ui.all_tickets",
  "All time": "admin.ui.all_time",
  "All trip types": "admin.ui.all_trip_types",
  "All types": "admin.ui.all_types",
  "All users": "admin.ui.all_users",
  "All zones": "admin.ui.all_zones",
  "Allow driver counter-offers": "admin.ui.allow_driver_counter_offers",
  "Allow substitution if out of stock": "admin.ui.allow_substitution_if_out_of_stock",
  "Always on": "admin.ui.always_on",
  "Amount": "admin.ui.amount",
  "Amount / Subtotal": "admin.ui.amount_subtotal",
  "Analytics + Order Reports": "admin.ui.analytics_order_reports",
  "Analytics command center": "admin.ui.analytics_command_center",
  "Android / Play Store": "admin.ui.android_play_store",
  "App": "admin.ui.app",
  "App area": "admin.ui.app_area",
  "App Store": "admin.ui.app_store",
  "App Store · iOS": "admin.ui.app_store_ios",
  "Apply from masters": "admin.ui.apply_from_masters",
  "Apply pricing template (optional)": "admin.ui.apply_pricing_template_optional",
  "Apply to all": "admin.ui.apply_to_all",
  "Approval": "admin.ui.approval",
  "Approval & Revenue": "admin.ui.approval_revenue",
  "Approval Status": "admin.ui.approval_status",
  "Approve": "admin.ui.approve",
  "Approved": "admin.ui.approved",
  "Arrive at Customer": "admin.ui.arrive_at_customer",
  "Arrive at Restaurant": "admin.ui.arrive_at_restaurant",
  "Arrive at Store": "admin.ui.arrive_at_store",
  "Assign": "admin.ui.assign",
  "Assign & Notify": "admin.ui.assign_notify",
  "Assign Driver": "admin.ui.assign_driver",
  "Assign Partner": "admin.ui.assign_partner",
  "Assign to": "admin.ui.assign_to",
  "Assigned": "admin.ui.assigned",
  "Assigned Roles": "admin.ui.assigned_roles",
  "Assignee": "admin.ui.assignee",
  "Attribute Values": "admin.ui.attribute_values",
  "Audience": "admin.ui.audience",
  "Audio": "admin.ui.audio",
  "Audit": "admin.ui.audit",
  "Auto-accept lowest bid when window expires": "admin.ui.auto_accept_lowest_bid_when_window_expires",
  "Auto-accept ON": "admin.ui.auto_accept_on",
  "Auto-dispatch delivery partner": "admin.ui.auto_dispatch_delivery_partner",
  "Auto-Dispatch Partners": "admin.ui.auto_dispatch_partners",
  "Auto-fill code from name": "admin.ui.auto_fill_code_from_name",
  "Auto-fill code from plan name": "admin.ui.auto_fill_code_from_plan_name",
  "Auto-fill plan code from plan name": "admin.ui.auto_fill_plan_code_from_plan_name",
  "Auto-renew at end of billing cycle": "admin.ui.auto_renew_at_end_of_billing_cycle",
  "Auto-verify on create (skip document approval)": "admin.ui.auto_verify_on_create_skip_document_approval",
  "Auto-verify partner (skip document approval queue)": "admin.ui.auto_verify_partner_skip_document_approval_queue",
  "Availability Schedule": "admin.ui.availability_schedule",
  "Availability schedules": "admin.ui.availability_schedules",
  "Availability Schedules": "admin.ui.availability_schedules_2",
  "Available": "admin.ui.available",
  "Avg Pick Time (mins)": "admin.ui.avg_pick_time_mins",
  "Awaiting approval": "admin.ui.awaiting_approval",
  "Back to roles": "admin.ui.back_to_roles",
  "Badge label": "admin.ui.badge_label",
  "Balance": "admin.ui.balance",
  "Balance after": "admin.ui.balance_after",
  "Banks": "admin.ui.banks",
  "Banner URL": "admin.ui.banner_url",
  "Base": "admin.ui.base",
  "Base ₹": "admin.ui.base_2",
  "Base Distance": "admin.ui.base_distance",
  "Base Fare": "admin.ui.base_fare",
  "Base KM (included)": "admin.ui.base_km_included",
  "Base price": "admin.ui.base_price",
  "Base Price": "admin.ui.base_price_2",
  "Base Price (₹)": "admin.ui.base_price_3",
  "Based on country": "admin.ui.based_on_country",
  "Basic": "admin.ui.basic",
  "Basic details": "admin.ui.basic_details",
  "Basic Details": "admin.ui.basic_details_2",
  "Basic info": "admin.ui.basic_info",
  "Batch delivery (multiple orders same route)": "admin.ui.batch_delivery_multiple_orders_same_route",
  "Benefits & publish": "admin.ui.benefits_publish",
  "Bestseller": "admin.ui.bestseller",
  "Bidding": "admin.ui.bidding",
  "Bidding Max": "admin.ui.bidding_max",
  "Bidding Min": "admin.ui.bidding_min",
  "Bidding zone (transport / taxi)": "admin.ui.bidding_zone_transport_taxi",
  "Bike Rental": "admin.ui.bike_rental",
  "Bike Rental Setup": "admin.ui.bike_rental_setup",
  "Billing": "admin.ui.billing",
  "Billing cycle": "admin.ui.billing_cycle",
  "Billing Email": "admin.ui.billing_email",
  "Billing email *": "admin.ui.billing_email_2",
  "Billing phone (optional)": "admin.ui.billing_phone_optional",
  "Blocked": "admin.ui.blocked",
  "Blocked by admin": "admin.ui.blocked_by_admin",
  "Blocked Reason": "admin.ui.blocked_reason",
  "Body": "admin.ui.body",
  "Bonus": "admin.ui.bonus",
  "Bonus amount (₹)": "admin.ui.bonus_amount",
  "Book": "admin.ui.book",
  "Book a Ride": "admin.ui.book_a_ride",
  "Book Ride": "admin.ui.book_ride",
  "Book rides, advance workflow stages, assign drivers, and rate completed trips.": "admin.ui.book_rides_advance_workflow_stages_assign_drivers_and_rate_completed_trips",
  "Booking for": "admin.ui.booking_for",
  "Booking For": "admin.ui.booking_for_2",
  "Booking Setup Guide": "admin.ui.booking_setup_guide",
  "Bookings": "admin.ui.bookings",
  "Both": "admin.ui.both",
  "Branch": "admin.ui.branch",
  "Branch (optional)": "admin.ui.branch_optional",
  "Branch Master": "admin.ui.branch_master",
  "Brand": "admin.ui.brand",
  "Brand, model, variant, color, fuel": "admin.ui.brand_model_variant_color_fuel",
  "Branding": "admin.ui.branding",
  "Brands": "admin.ui.brands",
  "Broadcast": "admin.ui.broadcast",
  "Browse Restaurants": "admin.ui.browse_restaurants",
  "Browse Stores": "admin.ui.browse_stores",
  "Bug fixes and performance improvements": "admin.ui.bug_fixes_and_performance_improvements",
  "Build": "admin.ui.build",
  "Build number": "admin.ui.build_number",
  "Business": "admin.ui.business",
  "Business Type": "admin.ui.business_type",
  "Business, vehicle, referral, and commission settings": "admin.ui.business_vehicle_referral_and_commission_settings",
  "Busy Drivers": "admin.ui.busy_drivers",
  "Calories (kcal)": "admin.ui.calories_kcal",
  "Campaign": "admin.ui.campaign",
  "Cancel": "admin.ui.cancel",
  "Cancel rate": "admin.ui.cancel_rate",
  "Cancel Reasons + Penalties": "admin.ui.cancel_reasons_penalties",
  "Cancellation + Refund Policy": "admin.ui.cancellation_refund_policy",
  "Cancellation Fee (after accept)": "admin.ui.cancellation_fee_after_accept",
  "Cancellation Fee (after arrive)": "admin.ui.cancellation_fee_after_arrive",
  "Cancellation Policies": "admin.ui.cancellation_policies",
  "Cancellation reasons": "admin.ui.cancellation_reasons",
  "Cancellation Reasons": "admin.ui.cancellation_reasons_2",
  "Cancelled": "admin.ui.cancelled",
  "Capacity (seats)": "admin.ui.capacity_seats",
  "Car Rental": "admin.ui.car_rental",
  "Car Rental Setup": "admin.ui.car_rental_setup",
  "Carbohydrates (g)": "admin.ui.carbohydrates_g",
  "Card": "admin.ui.card",
  "Card / Online": "admin.ui.card_online",
  "Carousel images on Taxi, Porter, and Provider tabs in the customer app": "admin.ui.carousel_images_on_taxi_porter_and_provider_tabs_in_the_customer_app",
  "Cart Checkout": "admin.ui.cart_checkout",
  "Cash": "admin.ui.cash",
  "Cash, wallet, and card/online payments across transport, delivery, and services.": "admin.ui.cash_wallet_and_card_online_payments_across_transport_delivery_and_services",
  "Cashfree": "admin.ui.cashfree",
  "Catalog": "admin.ui.catalog",
  "Catalog / Stores": "admin.ui.catalog_stores",
  "Categories": "admin.ui.categories",
  "Categories (primary → sub), skills, certificates, experience": "admin.ui.categories_primary_sub_skills_certificates_experience",
  "Category": "admin.ui.category",
  "Category *": "admin.ui.category_2",
  "Category image": "admin.ui.category_image",
  "Category, sub-category, cuisine, dietary, tags": "admin.ui.category_sub_category_cuisine_dietary_tags",
  "Certificates": "admin.ui.certificates",
  "Change type": "admin.ui.change_type",
  "Channel": "admin.ui.channel",
  "Chat": "admin.ui.chat",
  "Checkout": "admin.ui.checkout",
  "Choose a report to open it on a dedicated page with filters, search, and export.": "admin.ui.choose_a_report_to_open_it_on_a_dedicated_page_with_filters_search_and_export",
  "Choose hub first — Transport, Delivery, or On Demand": "admin.ui.choose_hub_first_transport_delivery_or_on_demand",
  "City": "admin.ui.city",
  "City or area name": "admin.ui.city_or_area_name",
  "City Required": "admin.ui.city_required",
  "City-to-city route packages with driver allowance, per-km rate, and round-trip multiplier.": "admin.ui.city_to_city_route_packages_with_driver_allowance_per_km_rate_and_round_trip_mul",
  "Clear": "admin.ui.clear",
  "Clear subscription filter": "admin.ui.clear_subscription_filter",
  "Client Admin": "admin.ui.client_admin",
  "Client Admin (within tenant)": "admin.ui.client_admin_within_tenant",
  "Client Management": "admin.ui.client_management",
  "Close": "admin.ui.close",
  "Close catalog": "admin.ui.close_catalog",
  "Close flow guide": "admin.ui.close_flow_guide",
  "Closed": "admin.ui.closed",
  "Code": "admin.ui.code",
  "Code (auto-generated if blank)": "admin.ui.code_auto_generated_if_blank",
  "Code, name, and description": "admin.ui.code_name_and_description",
  "Code, zone, and partner type": "admin.ui.code_zone_and_partner_type",
  "Combined with date range (AND)": "admin.ui.combined_with_date_range_and",
  "Comma-separated certificate names/codes": "admin.ui.comma_separated_certificate_names_codes",
  "Comments": "admin.ui.comments",
  "Commission": "admin.ui.commission",
  "Commission (zone %)": "admin.ui.commission_zone",
  "Commission %": "admin.ui.commission_2",
  "Commission + Settlements": "admin.ui.commission_settlements",
  "Commission based": "admin.ui.commission_based",
  "Commission rate (%)": "admin.ui.commission_rate",
  "Commission rules, features, badges, and visibility": "admin.ui.commission_rules_features_badges_and_visibility",
  "Commission Settlements": "admin.ui.commission_settlements_2",
  "Commission structure (% or fixed per order)": "admin.ui.commission_structure_or_fixed_per_order",
  "Commission structure per order": "admin.ui.commission_structure_per_order",
  "Commission Type": "admin.ui.commission_type",
  "Commission Value": "admin.ui.commission_value",
  "Company": "admin.ui.company",
  "Company name": "admin.ui.company_name",
  "Company name *": "admin.ui.company_name_2",
  "Complaint": "admin.ui.complaint",
  "Complaints only": "admin.ui.complaints_only",
  "Complete": "admin.ui.complete",
  "Complete capability breakdown — roles, permissions, and hub tab actions.": "admin.ui.complete_capability_breakdown_roles_permissions_and_hub_tab_actions",
  "Complete capability breakdown for Super Admin, Client Admin, and Employee roles": "admin.ui.complete_capability_breakdown_for_super_admin_client_admin_and_employee_roles",
  "Complete Trip": "admin.ui.complete_trip",
  "Completed": "admin.ui.completed",
  "Completed trips in the selected date range": "admin.ui.completed_trips_in_the_selected_date_range",
  "Completed vs cancelled": "admin.ui.completed_vs_cancelled",
  "Completed vs cancelled trends and payment channel breakdown": "admin.ui.completed_vs_cancelled_trends_and_payment_channel_breakdown",
  "Completion": "admin.ui.completion",
  "Component": "admin.ui.component",
  "Configurable options → generated variants": "admin.ui.configurable_options_generated_variants",
  "Configurable service options": "admin.ui.configurable_service_options",
  "Configuration": "admin.ui.configuration",
  "Configure drag-and-drop KPI dashboards per role — driver, merchant, provider, admin, and more.": "admin.ui.configure_drag_and_drop_kpi_dashboards_per_role_driver_merchant_provider_admin_a",
  "Configure groups and document types partners must upload": "admin.ui.configure_groups_and_document_types_partners_must_upload",
  "Configure in Inventory, Purchase, Marketing modules": "admin.ui.configure_in_inventory_purchase_marketing_modules",
  "Configure platform services": "admin.ui.configure_platform_services",
  "Configure ride modes, vehicle types, and pricing masters.": "admin.ui.configure_ride_modes_vehicle_types_and_pricing_masters",
  "Configure RIDE NOW and RIDE LATER pricing per zone and vehicle type.": "admin.ui.configure_ride_now_and_ride_later_pricing_per_zone_and_vehicle_type",
  "Configure sub-service masters": "admin.ui.configure_sub_service_masters",
  "Configure Zones": "admin.ui.configure_zones",
  "Configured": "admin.ui.configured",
  "Confirm & apply": "admin.ui.confirm_apply",
  "Confirm & Pay": "admin.ui.confirm_pay",
  "Confirm password": "admin.ui.confirm_password",
  "Confirm Password": "admin.ui.confirm_password_2",
  "Confirmed": "admin.ui.confirmed",
  "Consultation Types": "admin.ui.consultation_types",
  "Consultation types, specializations, and session rules.": "admin.ui.consultation_types_specializations_and_session_rules",
  "Contact": "admin.ui.contact",
  "Contact Person": "admin.ui.contact_person",
  "Contact Phone": "admin.ui.contact_phone",
  "Contact support to change your phone number": "admin.ui.contact_support_to_change_your_phone_number",
  "Continue": "admin.ui.continue",
  "Contract": "admin.ui.contract",
  "Contract type *": "admin.ui.contract_type",
  "Converted": "admin.ui.converted",
  "Coordinate": "admin.ui.coordinate",
  "Core": "admin.ui.core",
  "Corporate Clients": "admin.ui.corporate_clients",
  "Cost": "admin.ui.cost",
  "Could not load tenants": "admin.ui.could_not_load_tenants",
  "Countries": "admin.ui.countries",
  "Countries — used in zone management and all services": "admin.ui.countries_used_in_zone_management_and_all_services",
  "Countries (comma-separated)": "admin.ui.countries_comma_separated",
  "Country": "admin.ui.country",
  "Country Required": "admin.ui.country_required",
  "Cover Image": "admin.ui.cover_image",
  "Coverage": "admin.ui.coverage",
  "Create": "admin.ui.create",
  "Create and edit master groups and types — no code deploy required.": "admin.ui.create_and_edit_master_groups_and_types_no_code_deploy_required",
  "Create time-boxed demo clients. One demo key = one company. Data is kept after expiry.": "admin.ui.create_time_boxed_demo_clients_one_demo_key_one_company_data_is_kept_after_expir",
  "Create Zone": "admin.ui.create_zone",
  "Create zones with polygon boundaries": "admin.ui.create_zones_with_polygon_boundaries",
  "Create, configure, suspend, and manage SaaS clients with full lifecycle control.": "admin.ui.create_configure_suspend_and_manage_saas_clients_with_full_lifecycle_control",
  "Created": "admin.ui.created",
  "Created at": "admin.ui.created_at",
  "Credentials (JSON)": "admin.ui.credentials_json",
  "Credit": "admin.ui.credit",
  "Credit limit": "admin.ui.credit_limit",
  "Credit Limit": "admin.ui.credit_limit_2",
  "Critical": "admin.ui.critical",
  "Cuisine": "admin.ui.cuisine",
  "Cuisine types + dietary tags (Veg / Non-Veg)": "admin.ui.cuisine_types_dietary_tags_veg_non_veg",
  "Currencies": "admin.ui.currencies",
  "Currency": "admin.ui.currency",
  "Custom": "admin.ui.custom",
  "Custom (start–end)": "admin.ui.custom_start_end",
  "Custom code": "admin.ui.custom_code",
  "Custom domain": "admin.ui.custom_domain",
  "Custom end date": "admin.ui.custom_end_date",
  "Custom services use Food or Grocery order flows": "admin.ui.custom_services_use_food_or_grocery_order_flows",
  "Custom time below": "admin.ui.custom_time_below",
  "Custom weight": "admin.ui.custom_weight",
  "Customer": "admin.ui.customer",
  "Customer App": "admin.ui.customer_app",
  "Customer books ride": "admin.ui.customer_books_ride",
  "Customer god view — trips, orders, complaints, ratings, and referrals": "admin.ui.customer_god_view_trips_orders_complaints_ratings_and_referrals",
  "Customer OTP (optional for admin)": "admin.ui.customer_otp_optional_for_admin",
  "Customer phone": "admin.ui.customer_phone",
  "Customer quote requests and provider responses": "admin.ui.customer_quote_requests_and_provider_responses",
  "Customer rating": "admin.ui.customer_rating",
  "Customer review": "admin.ui.customer_review",
  "Customer username": "admin.ui.customer_username",
  "Customers": "admin.ui.customers",
  "Customers, revenue, zones, and service volumes": "admin.ui.customers_revenue_zones_and_service_volumes",
  "Daily": "admin.ui.daily",
  "Daily / weekly earnings summary": "admin.ui.daily_weekly_earnings_summary",
  "Dangerous": "admin.ui.dangerous",
  "Dark Store (quick commerce)": "admin.ui.dark_store_quick_commerce",
  "Dashboard": "admin.ui.dashboard",
  "Dashboard Builder": "admin.ui.dashboard_builder",
  "Dashboard Engine": "admin.ui.dashboard_engine",
  "Data Source": "admin.ui.data_source",
  "Date": "admin.ui.date",
  "Date & Time": "admin.ui.date_time",
  "Date field": "admin.ui.date_field",
  "Date of Birth": "admin.ui.date_of_birth",
  "Date: All time": "admin.ui.date_all_time",
  "Day": "admin.ui.day",
  "Days": "admin.ui.days",
  "Days to add": "admin.ui.days_to_add",
  "Deactivate": "admin.ui.deactivate",
  "Deactivate document group?": "admin.ui.deactivate_document_group",
  "Deactivate group": "admin.ui.deactivate_group",
  "Deactivate service?": "admin.ui.deactivate_service",
  "Deactivate subscription plan?": "admin.ui.deactivate_subscription_plan",
  "Deactivated": "admin.ui.deactivated",
  "Declared value": "admin.ui.declared_value",
  "Default": "admin.ui.default",
  "Default language": "admin.ui.default_language",
  "Default special handling": "admin.ui.default_special_handling",
  "Delete": "admin.ui.delete",
  "Delete Account": "admin.ui.delete_account",
  "Delete incentive?": "admin.ui.delete_incentive",
  "Delete plan": "admin.ui.delete_plan",
  "Delete record?": "admin.ui.delete_record",
  "Delete service": "admin.ui.delete_service",
  "Delete sub-category?": "admin.ui.delete_sub_category",
  "Delete subscription plan?": "admin.ui.delete_subscription_plan",
  "Delete zone?": "admin.ui.delete_zone",
  "Deleted": "admin.ui.deleted",
  "Delivered": "admin.ui.delivered",
  "Delivered, cancelled, and past restaurant orders": "admin.ui.delivered_cancelled_and_past_restaurant_orders",
  "Delivered, cancelled, and past store orders": "admin.ui.delivered_cancelled_and_past_store_orders",
  "Delivered, cancelled, and refunded food orders": "admin.ui.delivered_cancelled_and_refunded_food_orders",
  "Deliveries": "admin.ui.deliveries",
  "Delivering": "admin.ui.delivering",
  "Delivery": "admin.ui.delivery",
  "Delivery Address": "admin.ui.delivery_address",
  "Delivery Address *": "admin.ui.delivery_address_2",
  "Delivery Modes": "admin.ui.delivery_modes",
  "Delivery OTP": "admin.ui.delivery_otp",
  "Delivery partner": "admin.ui.delivery_partner",
  "Delivery Partner": "admin.ui.delivery_partner_2",
  "Delivery Partner App": "admin.ui.delivery_partner_app",
  "Delivery partners": "admin.ui.delivery_partners",
  "Delivery Partners": "admin.ui.delivery_partners_2",
  "Delivery Person — Complete Flow": "admin.ui.delivery_person_complete_flow",
  "Delivery Radius (km)": "admin.ui.delivery_radius_km",
  "Delivery radius + zone fee slots": "admin.ui.delivery_radius_zone_fee_slots",
  "Delivery Slots": "admin.ui.delivery_slots",
  "Delivery zones + slot windows": "admin.ui.delivery_zones_slot_windows",
  "Demo actions": "admin.ui.demo_actions",
  "Demo key": "admin.ui.demo_key",
  "Demo Key": "admin.ui.demo_key_2",
  "Demo Management": "admin.ui.demo_management",
  "Demo ready": "admin.ui.demo_ready",
  "Denied": "admin.ui.denied",
  "Department": "admin.ui.department",
  "Depots, vehicle taxonomy, and zone-wise rental packages with per-vehicle pricing.": "admin.ui.depots_vehicle_taxonomy_and_zone_wise_rental_packages_with_per_vehicle_pricing",
  "Deprecated": "admin.ui.deprecated",
  "Describe the situation, contacts made, and resolution steps…": "admin.ui.describe_the_situation_contacts_made_and_resolution_steps",
  "Description": "admin.ui.description",
  "Details": "admin.ui.details",
  "Diamond": "admin.ui.diamond",
  "Dietary Type": "admin.ui.dietary_type",
  "Dine In": "admin.ui.dine_in",
  "Direct Order": "admin.ui.direct_order",
  "Discount": "admin.ui.discount",
  "Discount & Offers": "admin.ui.discount_offers",
  "Discount codes applied at food checkout for your restaurant": "admin.ui.discount_codes_applied_at_food_checkout_for_your_restaurant",
  "Discount codes synced to Transport fare, Porter booking, and Provider checkout": "admin.ui.discount_codes_synced_to_transport_fare_porter_booking_and_provider_checkout",
  "Discount type": "admin.ui.discount_type",
  "Discount Type": "admin.ui.discount_type_2",
  "Discount value": "admin.ui.discount_value",
  "Discount Value": "admin.ui.discount_value_2",
  "Discounts": "admin.ui.discounts",
  "Dispatch": "admin.ui.dispatch",
  "Dispatch Queue": "admin.ui.dispatch_queue",
  "Dispatcher": "admin.ui.dispatcher",
  "Dispatcher — live rides & orders": "admin.ui.dispatcher_live_rides_orders",
  "Dispatcher Live Map": "admin.ui.dispatcher_live_map",
  "Dispatcher operations (live rides / orders)": "admin.ui.dispatcher_operations_live_rides_orders",
  "Dispatcher ready": "admin.ui.dispatcher_ready",
  "Display name": "admin.ui.display_name",
  "Display name shown to partners, e.g. Driving licence": "admin.ui.display_name_shown_to_partners_e_g_driving_licence",
  "Display Order": "admin.ui.display_order",
  "Distance (km)": "admin.ui.distance_km",
  "Distance (KM)": "admin.ui.distance_km_2",
  "Distance charge": "admin.ui.distance_charge",
  "Document": "admin.ui.document",
  "Document code": "admin.ui.document_code",
  "Document Groups": "admin.ui.document_groups",
  "Document name": "admin.ui.document_name",
  "Document number (optional)": "admin.ui.document_number_optional",
  "Document number required": "admin.ui.document_number_required",
  "Documents": "admin.ui.documents",
  "Documents waiting": "admin.ui.documents_waiting",
  "Documents, vehicle, and bank details": "admin.ui.documents_vehicle_and_bank_details",
  "Draft": "admin.ui.draft",
  "Drag white corner handles to reshape — blue fill is the zone only": "admin.ui.drag_white_corner_handles_to_reshape_blue_fill_is_the_zone_only",
  "Driver": "admin.ui.driver",
  "Driver / Taxi Partner": "admin.ui.driver_taxi_partner",
  "Driver Allowance": "admin.ui.driver_allowance",
  "Driver Assigned": "admin.ui.driver_assigned",
  "Driver Documents": "admin.ui.driver_documents",
  "Driver leaderboard": "admin.ui.driver_leaderboard",
  "Driver Management": "admin.ui.driver_management",
  "Driver Notes": "admin.ui.driver_notes",
  "Driver Onboarding + KYC": "admin.ui.driver_onboarding_kyc",
  "Driver payout settled": "admin.ui.driver_payout_settled",
  "Driver Performance": "admin.ui.driver_performance",
  "Driver rating": "admin.ui.driver_rating",
  "Driver Registration": "admin.ui.driver_registration",
  "Driver review": "admin.ui.driver_review",
  "Driver username": "admin.ui.driver_username",
  "Drivers": "admin.ui.drivers",
  "Drivers / delivery partners": "admin.ui.drivers_delivery_partners",
  "Drop": "admin.ui.drop",
  "Drop address": "admin.ui.drop_address",
  "Drop lat": "admin.ui.drop_lat",
  "Drop lng": "admin.ui.drop_lng",
  "Drop Location": "admin.ui.drop_location",
  "Drop-off": "admin.ui.drop_off",
  "Drop-off (B)": "admin.ui.drop_off_b",
  "Dropoff": "admin.ui.dropoff",
  "Dropoff Address": "admin.ui.dropoff_address",
  "Dropoff Address *": "admin.ui.dropoff_address_2",
  "Duration": "admin.ui.duration",
  "Duration (min)": "admin.ui.duration_min",
  "Dynamic bookable services from Transport Hub — zone pricing, not Ride Category masters": "admin.ui.dynamic_bookable_services_from_transport_hub_zone_pricing_not_ride_category_mast",
  "Dynamic Engine": "admin.ui.dynamic_engine",
  "e.g. 1 plate, 250g": "admin.ui.e_g_1_plate_250g",
  "e.g. 2 hr / 40 km": "admin.ui.e_g_2_hr_40_km",
  "e.g. app.client.com": "admin.ui.e_g_app_client_com",
  "e.g. Bangalore ~ 12.97, 77.59": "admin.ui.e_g_bangalore_12_97_77_59",
  "e.g. client": "admin.ui.e_g_client",
  "e.g. nav.dashboard": "admin.ui.e_g_nav_dashboard",
  "e.g. Operations, Dispatch": "admin.ui.e_g_operations_dispatch",
  "e.g. Pharmacy Delivery": "admin.ui.e_g_pharmacy_delivery",
  "e.g. Pure veg kitchen, famous for biryani, open till midnight, delivery within 5 km…": "admin.ui.e_g_pure_veg_kitchen_famous_for_biryani_open_till_midnight_delivery_within_5_km",
  "e.g. SEDAN, SUV, BIKE": "admin.ui.e_g_sedan_suv_bike",
  "e.g. status, metricCode": "admin.ui.e_g_status_metriccode",
  "e.g. transport_masters, food_masters, pricing": "admin.ui.e_g_transport_masters_food_masters_pricing",
  "Earn Per ₹": "admin.ui.earn_per",
  "Earn Rate": "admin.ui.earn_rate",
  "Earned / Spent": "admin.ui.earned_spent",
  "Earnings": "admin.ui.earnings",
  "Earnings Detail": "admin.ui.earnings_detail",
  "Earnings Reports": "admin.ui.earnings_reports",
  "Earnings target": "admin.ui.earnings_target",
  "Edit": "admin.ui.edit",
  "Edit group": "admin.ui.edit_group",
  "Edit service": "admin.ui.edit_service",
  "Edit zone": "admin.ui.edit_zone",
  "Effective From": "admin.ui.effective_from",
  "Electrician, plumber, cleaning & more": "admin.ui.electrician_plumber_cleaning_more",
  "Email": "admin.ui.email",
  "Emergency Contact": "admin.ui.emergency_contact",
  "Employee": "admin.ui.employee",
  "Employee (Staff)": "admin.ui.employee_staff",
  "Employee / Staff": "admin.ui.employee_staff_2",
  "Employee ID": "admin.ui.employee_id",
  "Empty = all zones": "admin.ui.empty_all_zones",
  "Empty = available in all zones": "admin.ui.empty_available_in_all_zones",
  "Enable modules for tenant": "admin.ui.enable_modules_for_tenant",
  "Enable push notifications": "admin.ui.enable_push_notifications",
  "Enable this service in zones": "admin.ui.enable_this_service_in_zones",
  "Enable this sub-service in each zone": "admin.ui.enable_this_sub_service_in_each_zone",
  "Enabled": "admin.ui.enabled",
  "End date": "admin.ui.end_date",
  "End Date": "admin.ui.end_date_2",
  "End time": "admin.ui.end_time",
  "End-to-end food delivery operations": "admin.ui.end_to_end_food_delivery_operations",
  "Ends at": "admin.ui.ends_at",
  "English": "admin.ui.english",
  "English slug xxxx-xxxx format": "admin.ui.english_slug_xxxx_xxxx_format",
  "Enter 4-digit code": "admin.ui.enter_4_digit_code",
  "Enter OTP if available; admins may complete without it": "admin.ui.enter_otp_if_available_admins_may_complete_without_it",
  "Enter the code sent to your phone or email": "admin.ui.enter_the_code_sent_to_your_phone_or_email",
  "Escalated": "admin.ui.escalated",
  "Escalations": "admin.ui.escalations",
  "Event": "admin.ui.event",
  "Event code": "admin.ui.event_code",
  "Events & Tickets": "admin.ui.events_tickets",
  "example: payu": "admin.ui.example_payu",
  "Exchange Rates": "admin.ui.exchange_rates",
  "Excluded (actual cost)": "admin.ui.excluded_actual_cost",
  "Existing customer": "admin.ui.existing_customer",
  "Experience (years)": "admin.ui.experience_years",
  "Experience Levels": "admin.ui.experience_levels",
  "Expired": "admin.ui.expired",
  "Expiry": "admin.ui.expiry",
  "Expiry date": "admin.ui.expiry_date",
  "Expiry required": "admin.ui.expiry_required",
  "Explain what the partner should fix and re-upload": "admin.ui.explain_what_the_partner_should_fix_and_re_upload",
  "Export": "admin.ui.export",
  "Extend by": "admin.ui.extend_by",
  "Extra KM Price": "admin.ui.extra_km_price",
  "Failed": "admin.ui.failed",
  "Fallback Base Fare": "admin.ui.fallback_base_fare",
  "Fallback Per Kg": "admin.ui.fallback_per_kg",
  "Fallback Per Km": "admin.ui.fallback_per_km",
  "Fare": "admin.ui.fare",
  "Fare calculator": "admin.ui.fare_calculator",
  "Fare from zone matrix": "admin.ui.fare_from_zone_matrix",
  "Fat (g)": "admin.ui.fat_g",
  "Favicon": "admin.ui.favicon",
  "FCM server key": "admin.ui.fcm_server_key",
  "Featured": "admin.ui.featured",
  "Featured plan": "admin.ui.featured_plan",
  "Female": "admin.ui.female",
  "Festival": "admin.ui.festival",
  "Fiber (g)": "admin.ui.fiber_g",
  "File URL": "admin.ui.file_url",
  "Filter by zone name or code": "admin.ui.filter_by_zone_name_or_code",
  "Finance": "admin.ui.finance",
  "Finance & Reports": "admin.ui.finance_reports",
  "Finance: settlements + reports": "admin.ui.finance_settlements_reports",
  "Find": "admin.ui.find",
  "Find a master…": "admin.ui.find_a_master",
  "Fine": "admin.ui.fine",
  "First name": "admin.ui.first_name",
  "First Name": "admin.ui.first_name_2",
  "First order only": "admin.ui.first_order_only",
  "Fixed": "admin.ui.fixed",
  "Fixed (₹)": "admin.ui.fixed_2",
  "Fixed amount (₹)": "admin.ui.fixed_amount",
  "Flags": "admin.ui.flags",
  "Fleet Branch": "admin.ui.fleet_branch",
  "Fleet Branch / Depot": "admin.ui.fleet_branch_depot",
  "Fleet depots, rental-enabled vehicle types, and hour/km packages — like transport rental management.": "admin.ui.fleet_depots_rental_enabled_vehicle_types_and_hour_km_packages_like_transport_re",
  "Follow the recommended order to configure this sub-service.": "admin.ui.follow_the_recommended_order_to_configure_this_sub_service",
  "Font family": "admin.ui.font_family",
  "Food & Grocery Delivery — Complete Flow": "admin.ui.food_grocery_delivery_complete_flow",
  "Food Add Screen": "admin.ui.food_add_screen",
  "Food Attributes": "admin.ui.food_attributes",
  "Food Catalog": "admin.ui.food_catalog",
  "Food Code": "admin.ui.food_code",
  "Food Delivery": "admin.ui.food_delivery",
  "Food Delivery — End-to-End Flow": "admin.ui.food_delivery_end_to_end_flow",
  "Food Delivery Operations": "admin.ui.food_delivery_operations",
  "Food Images": "admin.ui.food_images",
  "Food Items": "admin.ui.food_items",
  "Food Name": "admin.ui.food_name",
  "Food Order History": "admin.ui.food_order_history",
  "Food Orders": "admin.ui.food_orders",
  "Food Tags": "admin.ui.food_tags",
  "Food-style (restaurants / meals)": "admin.ui.food_style_restaurants_meals",
  "Force update message": "admin.ui.force_update_message",
  "Fragile": "admin.ui.fragile",
  "Free waiting (min)": "admin.ui.free_waiting_min",
  "Free Waiting Time": "admin.ui.free_waiting_time",
  "Friday": "admin.ui.friday",
  "From": "admin.ui.from",
  "From City": "admin.ui.from_city",
  "From date": "admin.ui.from_date",
  "From Date": "admin.ui.from_date_2",
  "Frozen": "admin.ui.frozen",
  "FSSAI Number": "admin.ui.fssai_number",
  "Fuel Type": "admin.ui.fuel_type",
  "Fulfillment, SKU templates, tax": "admin.ui.fulfillment_sku_templates_tax",
  "Full analytics dashboard": "admin.ui.full_analytics_dashboard",
  "Full audit log visibility across all tenants": "admin.ui.full_audit_log_visibility_across_all_tenants",
  "Full CRUD with search, filter, and CSV export": "admin.ui.full_crud_with_search_filter_and_csv_export",
  "Full Function Reference": "admin.ui.full_function_reference",
  "Full partner review": "admin.ui.full_partner_review",
  "Full product records with variants, addons, and metadata from Food Add Wizard": "admin.ui.full_product_records_with_variants_addons_and_metadata_from_food_add_wizard",
  "Full store master — identity, location, compliance, delivery settings, timing, and revenue.": "admin.ui.full_store_master_identity_location_compliance_delivery_settings_timing_and_reve",
  "Gateway Type": "admin.ui.gateway_type",
  "Gender": "admin.ui.gender",
  "General": "admin.ui.general",
  "Glass": "admin.ui.glass",
  "Global permission & role templates": "admin.ui.global_permission_role_templates",
  "Go Online": "admin.ui.go_online",
  "Gold": "admin.ui.gold",
  "Goods": "admin.ui.goods",
  "Goods category": "admin.ui.goods_category",
  "Goods description": "admin.ui.goods_description",
  "Grace (min)": "admin.ui.grace_min",
  "Grace period (days)": "admin.ui.grace_period_days",
  "Grocery": "admin.ui.grocery",
  "Grocery Add Screen": "admin.ui.grocery_add_screen",
  "Grocery Delivery — Complete Flow": "admin.ui.grocery_delivery_complete_flow",
  "Grocery Delivery — End-to-End Flow": "admin.ui.grocery_delivery_end_to_end_flow",
  "Grocery Order History": "admin.ui.grocery_order_history",
  "Grocery Orders": "admin.ui.grocery_orders",
  "Grocery store onboarding + verification": "admin.ui.grocery_store_onboarding_verification",
  "Grocery-style (stores / catalog)": "admin.ui.grocery_style_stores_catalog",
  "Gross": "admin.ui.gross",
  "Gross Revenue": "admin.ui.gross_revenue",
  "Group": "admin.ui.group",
  "Group By field": "admin.ui.group_by_field",
  "Group Key": "admin.ui.group_key",
  "Group name": "admin.ui.group_name",
  "Groups and modifiers": "admin.ui.groups_and_modifiers",
  "Groups like Toppings, Sides, Beverages — each with priced addons.": "admin.ui.groups_like_toppings_sides_beverages_each_with_priced_addons",
  "GST %": "admin.ui.gst",
  "GST Number": "admin.ui.gst_number",
  "Handles food, grocery, and parcel deliveries. Same partner, multiple services.": "admin.ui.handles_food_grocery_and_parcel_deliveries_same_partner_multiple_services",
  "Handling": "admin.ui.handling",
  "Handoff OTP": "admin.ui.handoff_otp",
  "Heat Points": "admin.ui.heat_points",
  "Heavy": "admin.ui.heavy",
  "Heavy Order": "admin.ui.heavy_order",
  "Helpdesk": "admin.ui.helpdesk",
  "Helper": "admin.ui.helper",
  "Helpers": "admin.ui.helpers",
  "High": "admin.ui.high",
  "Highlights & publish": "admin.ui.highlights_publish",
  "Holidays": "admin.ui.holidays",
  "Home Banners": "admin.ui.home_banners",
  "Home delivery": "admin.ui.home_delivery",
  "Hour and kilometer rental package master — define packages per vehicle type.": "admin.ui.hour_and_kilometer_rental_package_master_define_packages_per_vehicle_type",
  "Hour/km bundles with per-vehicle pricing": "admin.ui.hour_km_bundles_with_per_vehicle_pricing",
  "Hourly": "admin.ui.hourly",
  "Hourly job volume (last 4 hours) — transport, delivery, and services": "admin.ui.hourly_job_volume_last_4_hours_transport_delivery_and_services",
  "Hours": "admin.ui.hours",
  "How drivers earn in this zone": "admin.ui.how_drivers_earn_in_this_zone",
  "Hub": "admin.ui.hub",
  "Hub tab reference — Food Delivery": "admin.ui.hub_tab_reference_food_delivery",
  "Hub tab reference — Grocery Delivery": "admin.ui.hub_tab_reference_grocery_delivery",
  "Hub tab reference — Services": "admin.ui.hub_tab_reference_services",
  "Hub tab reference — Transport": "admin.ui.hub_tab_reference_transport",
  "Icon": "admin.ui.icon",
  "Icon URL": "admin.ui.icon_url",
  "ID #": "admin.ui.id",
  "Image": "admin.ui.image",
  "In progress": "admin.ui.in_progress",
  "In Progress": "admin.ui.in_progress_2",
  "In queue": "admin.ui.in_queue",
  "In-app": "admin.ui.in_app",
  "IN,US,UAE": "admin.ui.in_us_uae",
  "Inactive": "admin.ui.inactive",
  "Inactive flag": "admin.ui.inactive_flag",
  "Incentive campaigns": "admin.ui.incentive_campaigns",
  "Incentive Options": "admin.ui.incentive_options",
  "Incentive Type": "admin.ui.incentive_type",
  "Incentives & Bonuses": "admin.ui.incentives_bonuses",
  "Incident report *": "admin.ui.incident_report",
  "Included in fare": "admin.ui.included_in_fare",
  "Individual users (search & multiselect)": "admin.ui.individual_users_search_multiselect",
  "Ingredient & Recipe": "admin.ui.ingredient_recipe",
  "Insights": "admin.ui.insights",
  "Insurance": "admin.ui.insurance",
  "Insurance eligible": "admin.ui.insurance_eligible",
  "Intercity": "admin.ui.intercity",
  "Internal Admin Notes": "admin.ui.internal_admin_notes",
  "Internal AE / owner": "admin.ui.internal_ae_owner",
  "Internal notes": "admin.ui.internal_notes",
  "Interval": "admin.ui.interval",
  "Invoices": "admin.ui.invoices",
  "iOS / App Store": "admin.ui.ios_app_store",
  "Item": "admin.ui.item",
  "Items": "admin.ui.items",
  "Job description": "admin.ui.job_description",
  "Joined": "admin.ui.joined",
  "Jump to key admin areas": "admin.ui.jump_to_key_admin_areas",
  "Key": "admin.ui.key",
  "Key ID": "admin.ui.key_id",
  "Key name": "admin.ui.key_name",
  "Key Secret": "admin.ui.key_secret",
  "Kg": "admin.ui.kg",
  "Kitchen Station": "admin.ui.kitchen_station",
  "Km": "admin.ui.km",
  "L×W×H": "admin.ui.l_w_h",
  "L×W×H (cm)": "admin.ui.l_w_h_cm",
  "Label": "admin.ui.label",
  "Landmark": "admin.ui.landmark",
  "Language": "admin.ui.language",
  "Languages": "admin.ui.languages",
  "Languages (comma separated)": "admin.ui.languages_comma_separated",
  "Languages, currencies, timezones, tax regions": "admin.ui.languages_currencies_timezones_tax_regions",
  "Last Login": "admin.ui.last_login",
  "Last name": "admin.ui.last_name",
  "Last Name": "admin.ui.last_name_2",
  "Lat": "admin.ui.lat",
  "Latest": "admin.ui.latest",
  "Latest transport and delivery jobs": "admin.ui.latest_transport_and_delivery_jobs",
  "Latitude": "admin.ui.latitude",
  "Leaderboard": "admin.ui.leaderboard",
  "Leaderboard rankings and incentive campaigns": "admin.ui.leaderboard_rankings_and_incentive_campaigns",
  "Leave empty for all service hubs": "admin.ui.leave_empty_for_all_service_hubs",
  "Leave empty for full refund": "admin.ui.leave_empty_for_full_refund",
  "Lifetime": "admin.ui.lifetime",
  "Limit": "admin.ui.limit",
  "Line Chart": "admin.ui.line_chart",
  "Liquid": "admin.ui.liquid",
  "List": "admin.ui.list",
  "List Source": "admin.ui.list_source",
  "Live": "admin.ui.live",
  "Live Fleet Map": "admin.ui.live_fleet_map",
  "Live Food Orders": "admin.ui.live_food_orders",
  "Live Grocery Orders": "admin.ui.live_grocery_orders",
  "Live jobs": "admin.ui.live_jobs",
  "Live Map": "admin.ui.live_map",
  "Live map navigation integrated": "admin.ui.live_map_navigation_integrated",
  "Live Orders": "admin.ui.live_orders",
  "Live Partner Map": "admin.ui.live_partner_map",
  "Live partners": "admin.ui.live_partners",
  "Live Tracking": "admin.ui.live_tracking",
  "Live Trip": "admin.ui.live_trip",
  "Lng": "admin.ui.lng",
  "Load from masters": "admin.ui.load_from_masters",
  "Loading…": "admin.ui.loading",
  "Local": "admin.ui.local",
  "Locale & domain": "admin.ui.locale_domain",
  "Localization": "admin.ui.localization",
  "Locate me": "admin.ui.locate_me",
  "Location": "admin.ui.location",
  "Location, preferences, and internal admin notes": "admin.ui.location_preferences_and_internal_admin_notes",
  "Login & security": "admin.ui.login_security",
  "Logo": "admin.ui.logo",
  "Logo URL": "admin.ui.logo_url",
  "Longitude": "admin.ui.longitude",
  "Low": "admin.ui.low",
  "Lower numbers appear first in lists": "admin.ui.lower_numbers_appear_first_in_lists",
  "Lowest": "admin.ui.lowest",
  "Loyalty": "admin.ui.loyalty",
  "Maintenance": "admin.ui.maintenance",
  "Maintenance message": "admin.ui.maintenance_message",
  "Maintenance mode (blocks app on splash)": "admin.ui.maintenance_mode_blocks_app_on_splash",
  "Male": "admin.ui.male",
  "Manage": "admin.ui.manage",
  "Manage all tenants (create / suspend / config)": "admin.ui.manage_all_tenants_create_suspend_config",
  "Manage customer support tickets": "admin.ui.manage_customer_support_tickets",
  "Manage documents": "admin.ui.manage_documents",
  "Manage partner subscription plans": "admin.ui.manage_partner_subscription_plans",
  "Manage Partners": "admin.ui.manage_partners",
  "Manage plans": "admin.ui.manage_plans",
  "Manage riders": "admin.ui.manage_riders",
  "Manage Tenants": "admin.ui.manage_tenants",
  "Manage vehicle categories — capacity, service type, and availability.": "admin.ui.manage_vehicle_categories_capacity_service_type_and_availability",
  "Manage Venues (Masters)": "admin.ui.manage_venues_masters",
  "Mandatory": "admin.ui.mandatory",
  "Manual Booking": "admin.ui.manual_booking",
  "Manual Order": "admin.ui.manual_order",
  "Manual Ride Booking": "admin.ui.manual_ride_booking",
  "Map color": "admin.ui.map_color",
  "Mark all as read": "admin.ui.mark_all_as_read",
  "Mark Ready": "admin.ui.mark_ready",
  "Marketplace": "admin.ui.marketplace",
  "Master Builder": "admin.ui.master_builder",
  "Master Data": "admin.ui.master_data",
  "Master data & locale": "admin.ui.master_data_locale",
  "Master data builder (global masters)": "admin.ui.master_data_builder_global_masters",
  "Master Group Keys (comma-separated)": "admin.ui.master_group_keys_comma_separated",
  "Masters": "admin.ui.masters",
  "Max": "admin.ui.max",
  "Max discount (₹)": "admin.ui.max_discount",
  "Max Kg": "admin.ui.max_kg",
  "Max KM": "admin.ui.max_km",
  "Max qty": "admin.ui.max_qty",
  "Max Redeem %": "admin.ui.max_redeem",
  "Max rides per period": "admin.ui.max_rides_per_period",
  "Max users": "admin.ui.max_users",
  "Max uses / user": "admin.ui.max_uses_user",
  "Medical": "admin.ui.medical",
  "Membership": "admin.ui.membership",
  "Menu & Catalog": "admin.ui.menu_catalog",
  "Menu builder — categories, variants, addons": "admin.ui.menu_builder_categories_variants_addons",
  "Menu Item": "admin.ui.menu_item",
  "Menus": "admin.ui.menus",
  "Merchant": "admin.ui.merchant",
  "Merchant Account": "admin.ui.merchant_account",
  "Merchant Subscription Plan": "admin.ui.merchant_subscription_plan",
  "Message": "admin.ui.message",
  "Meta": "admin.ui.meta",
  "Metadata Engine": "admin.ui.metadata_engine",
  "Metric": "admin.ui.metric",
  "Metrics": "admin.ui.metrics",
  "MILE": "admin.ui.mile",
  "Min": "admin.ui.min",
  "Min / Force": "admin.ui.min_force",
  "Min Fare": "admin.ui.min_fare",
  "Min KM": "admin.ui.min_km",
  "Min order": "admin.ui.min_order",
  "Min Order": "admin.ui.min_order_2",
  "Min order (₹)": "admin.ui.min_order_3",
  "Min Order (₹)": "admin.ui.min_order_4",
  "Min Redeem": "admin.ui.min_redeem",
  "Min Redeem Points": "admin.ui.min_redeem_points",
  "Minimum Fare": "admin.ui.minimum_fare",
  "Mins": "admin.ui.mins",
  "Missing": "admin.ui.missing",
  "Mobile": "admin.ui.mobile",
  "Mobile / web push": "admin.ui.mobile_web_push",
  "Mobile number": "admin.ui.mobile_number",
  "Mode": "admin.ui.mode",
  "Module": "admin.ui.module",
  "Modules": "admin.ui.modules",
  "Monday": "admin.ui.monday",
  "Monitor all rides with live status, filter by date range, status, and trip type.": "admin.ui.monitor_all_rides_with_live_status_filter_by_date_range_status_and_trip_type",
  "Monitor earnings & process settlements": "admin.ui.monitor_earnings_process_settlements",
  "Monitor live dispatch queue": "admin.ui.monitor_live_dispatch_queue",
  "Monitor Operations": "admin.ui.monitor_operations",
  "Monitor Orders": "admin.ui.monitor_orders",
  "Monthly": "admin.ui.monthly",
  "More": "admin.ui.more",
  "More actions": "admin.ui.more_actions",
  "MSG91": "admin.ui.msg91",
  "Multi Order": "admin.ui.multi_order",
  "Multi-city operator branches": "admin.ui.multi_city_operator_branches",
  "Multi-Currency": "admin.ui.multi_currency",
  "Multi-outlet SaaS": "admin.ui.multi_outlet_saas",
  "Multi-restaurant ordering with real-time tracking": "admin.ui.multi_restaurant_ordering_with_real_time_tracking",
  "Multi-service: food + grocery + parcel same shift": "admin.ui.multi_service_food_grocery_parcel_same_shift",
  "Multi-store grocery ordering with slot-based delivery": "admin.ui.multi_store_grocery_ordering_with_slot_based_delivery",
  "Multiplier": "admin.ui.multiplier",
  "My Account": "admin.ui.my_account",
  "My Current Location": "admin.ui.my_current_location",
  "My Profile": "admin.ui.my_profile",
  "Myself": "admin.ui.myself",
  "Name": "admin.ui.name",
  "Name *": "admin.ui.name_2",
  "Name or phone": "admin.ui.name_or_phone",
  "Name, contact, avatar, and identity details": "admin.ui.name_contact_avatar_and_identity_details",
  "Name, email, or phone": "admin.ui.name_email_or_phone",
  "Name, phone, email…": "admin.ui.name_phone_email",
  "Navigate Pickup": "admin.ui.navigate_pickup",
  "Navigate to Customer": "admin.ui.navigate_to_customer",
  "Needs Action": "admin.ui.needs_action",
  "New customer": "admin.ui.new_customer",
  "New customer registrations · Click a point to view users registered on that date": "admin.ui.new_customer_registrations_click_a_point_to_view_users_registered_on_that_date",
  "New end date": "admin.ui.new_end_date",
  "New Order Alert": "admin.ui.new_order_alert",
  "New time": "admin.ui.new_time",
  "Next": "admin.ui.next",
  "Night": "admin.ui.night",
  "No activity in the last 4 hours": "admin.ui.no_activity_in_the_last_4_hours",
  "No data available": "admin.ui.no_data_available",
  "No mix data": "admin.ui.no_mix_data",
  "No outcome data": "admin.ui.no_outcome_data",
  "No package — visit charge only": "admin.ui.no_package_visit_charge_only",
  "No promo": "admin.ui.no_promo",
  "No revenue data yet": "admin.ui.no_revenue_data_yet",
  "No service data": "admin.ui.no_service_data",
  "No user growth data": "admin.ui.no_user_growth_data",
  "No zone": "admin.ui.no_zone",
  "No zones configured": "admin.ui.no_zones_configured",
  "No zones yet — create in Zone Management": "admin.ui.no_zones_yet_create_in_zone_management",
  "Non Verified": "admin.ui.non_verified",
  "Not uploaded": "admin.ui.not_uploaded",
  "Note": "admin.ui.note",
  "Note (optional)": "admin.ui.note_optional",
  "Notes / Description": "admin.ui.notes_description",
  "Notification templates": "admin.ui.notification_templates",
  "Notifications": "admin.ui.notifications",
  "Offer": "admin.ui.offer",
  "Offer Price (₹)": "admin.ui.offer_price",
  "Offers & Coupons": "admin.ui.offers_coupons",
  "Offline": "admin.ui.offline",
  "On Demand": "admin.ui.on_demand",
  "On hold": "admin.ui.on_hold",
  "On Trip": "admin.ui.on_trip",
  "On-demand": "admin.ui.on_demand_2",
  "On-demand Provider App": "admin.ui.on_demand_provider_app",
  "On-demand rides with zone-based pricing and bidding": "admin.ui.on_demand_rides_with_zone_based_pricing_and_bidding",
  "On-demand service": "admin.ui.on_demand_service",
  "On-Demand Service Provider": "admin.ui.on_demand_service_provider",
  "Onboard & verify drivers": "admin.ui.onboard_verify_drivers",
  "Onboard Drivers": "admin.ui.onboard_drivers",
  "Onboard drivers and assign zones": "admin.ui.onboard_drivers_and_assign_zones",
  "Onboard Partners": "admin.ui.onboard_partners",
  "Onboard Restaurants": "admin.ui.onboard_restaurants",
  "Onboard Stores": "admin.ui.onboard_stores",
  "Onboarding": "admin.ui.onboarding",
  "Onboarding Hub": "admin.ui.onboarding_hub",
  "Onboarding waiting": "admin.ui.onboarding_waiting",
  "One benefit per line\\ne.g. Email support\\n3 service hubs": "admin.ui.one_benefit_per_line_ne_g_email_support_n3_service_hubs",
  "One benefit per line\\ne.g. No commission on rides\\nPriority dispatch": "admin.ui.one_benefit_per_line_ne_g_no_commission_on_rides_npriority_dispatch",
  "One master: zone + vehicle + trip type": "admin.ui.one_master_zone_vehicle_trip_type",
  "One Way": "admin.ui.one_way",
  "Online": "admin.ui.online",
  "Online Drivers": "admin.ui.online_drivers",
  "Online/Offline toggle with zone selection": "admin.ui.online_offline_toggle_with_zone_selection",
  "Only active partners in your tenant roster are listed": "admin.ui.only_active_partners_in_your_tenant_roster_are_listed",
  "Open": "admin.ui.open",
  "Open Dispatcher": "admin.ui.open_dispatcher",
  "Open file": "admin.ui.open_file",
  "Open in new tab": "admin.ui.open_in_new_tab",
  "Open Invoices": "admin.ui.open_invoices",
  "Open master catalog": "admin.ui.open_master_catalog",
  "Open Now": "admin.ui.open_now",
  "Open setup guide": "admin.ui.open_setup_guide",
  "Open Users": "admin.ui.open_users",
  "Open Zone Management": "admin.ui.open_zone_management",
  "Opening Hours": "admin.ui.opening_hours",
  "Operating Zone": "admin.ui.operating_zone",
  "Operating zones": "admin.ui.operating_zones",
  "Operational control with live status transitions": "admin.ui.operational_control_with_live_status_transitions",
  "Operations": "admin.ui.operations",
  "Operations dashboard (permission-gated)": "admin.ui.operations_dashboard_permission_gated",
  "Operations that need your attention": "admin.ui.operations_that_need_your_attention",
  "Optional — applied to employee bookings billed to this account (0–100%)": "admin.ui.optional_applied_to_employee_bookings_billed_to_this_account_0_100",
  "Optional — multi-branch SaaS": "admin.ui.optional_multi_branch_saas",
  "Optional — must be zero or greater (defaults to ₹50,000)": "admin.ui.optional_must_be_zero_or_greater_defaults_to_50_000",
  "Optional — new customer registration only": "admin.ui.optional_new_customer_registration_only",
  "Optional admin notes": "admin.ui.optional_admin_notes",
  "Optional full-day off (in addition to per-day closed switches)": "admin.ui.optional_full_day_off_in_addition_to_per_day_closed_switches",
  "Optional invite / referral code": "admin.ui.optional_invite_referral_code",
  "Optional native build": "admin.ui.optional_native_build",
  "Optional tax identifier used in billing": "admin.ui.optional_tax_identifier_used_in_billing",
  "Options depend on country": "admin.ui.options_depend_on_country",
  "Options depend on the selected country": "admin.ui.options_depend_on_the_selected_country",
  "Or custom scheduled time": "admin.ui.or_custom_scheduled_time",
  "Or pick a preset above (1 / 3 / 7 / 15 / 30)": "admin.ui.or_pick_a_preset_above_1_3_7_15_30",
  "Order": "admin.ui.order",
  "Order #": "admin.ui.order_2",
  "Order # or booking #": "admin.ui.order_or_booking",
  "Order Assigned": "admin.ui.order_assigned",
  "Order detail — items, customer, partner, fare, and timeline": "admin.ui.order_detail_items_customer_partner_fare_and_timeline",
  "Order History": "admin.ui.order_history",
  "Order ID": "admin.ui.order_id",
  "Order No.": "admin.ui.order_no",
  "Order Notes": "admin.ui.order_notes",
  "Order Queue": "admin.ui.order_queue",
  "Orders": "admin.ui.orders",
  "Organizer Types": "admin.ui.organizer_types",
  "Organizers, venues, and policies": "admin.ui.organizers_venues_and_policies",
  "Other": "admin.ui.other",
  "Others": "admin.ui.others",
  "OTP code": "admin.ui.otp_code",
  "Out for Delivery": "admin.ui.out_for_delivery",
  "Out of zone": "admin.ui.out_of_zone",
  "Outstation": "admin.ui.outstation",
  "Outstation Management": "admin.ui.outstation_management",
  "Outstation mode": "admin.ui.outstation_mode",
  "Outstation pricing": "admin.ui.outstation_pricing",
  "Outstation Pricing": "admin.ui.outstation_pricing_2",
  "Outstation Pricing Management": "admin.ui.outstation_pricing_management",
  "Outstation Pricing Master": "admin.ui.outstation_pricing_master",
  "Outstation routes": "admin.ui.outstation_routes",
  "Overridden when a table row is marked Latest": "admin.ui.overridden_when_a_table_row_is_marked_latest",
  "Overridden when a table row is marked Min / Force": "admin.ui.overridden_when_a_table_row_is_marked_min_force",
  "Overview": "admin.ui.overview",
  "Owner": "admin.ui.owner",
  "Owner Name": "admin.ui.owner_name",
  "Package": "admin.ui.package",
  "Package (optional)": "admin.ui.package_optional",
  "Package code (SKU)": "admin.ui.package_code_sku",
  "Package Group": "admin.ui.package_group",
  "Package Hours": "admin.ui.package_hours",
  "Package image": "admin.ui.package_image",
  "Package KM": "admin.ui.package_km",
  "Package name": "admin.ui.package_name",
  "Package Name": "admin.ui.package_name_2",
  "Package pricing blueprints vs doorstep visit fees": "admin.ui.package_pricing_blueprints_vs_doorstep_visit_fees",
  "Package template": "admin.ui.package_template",
  "Package tier": "admin.ui.package_tier",
  "Packages": "admin.ui.packages",
  "Parking": "admin.ui.parking",
  "Partner": "admin.ui.partner",
  "Partner App": "admin.ui.partner_app",
  "Partner commission override (optional)": "admin.ui.partner_commission_override_optional",
  "Partner commission settlements for Transport, Porter, and Provider (on-demand).": "admin.ui.partner_commission_settlements_for_transport_porter_and_provider_on_demand",
  "Partner Details": "admin.ui.partner_details",
  "Partner earning model": "admin.ui.partner_earning_model",
  "Partner god view — requests, complaints, ratings, referrals, wallet, and fines": "admin.ui.partner_god_view_requests_complaints_ratings_referrals_wallet_and_fines",
  "Partner KYC & document review": "admin.ui.partner_kyc_document_review",
  "Partner KYC approval": "admin.ui.partner_kyc_approval",
  "Partner Onboarding": "admin.ui.partner_onboarding",
  "Partner Pricing (zone)": "admin.ui.partner_pricing_zone",
  "Partner Review": "admin.ui.partner_review",
  "Partner subscription plans": "admin.ui.partner_subscription_plans",
  "Partner Subscription Plans": "admin.ui.partner_subscription_plans_2",
  "Partner Tiers": "admin.ui.partner_tiers",
  "Partner type": "admin.ui.partner_type",
  "Partner types": "admin.ui.partner_types",
  "Partner user ID": "admin.ui.partner_user_id",
  "Partners": "admin.ui.partners",
  "Partners & Payout": "admin.ui.partners_payout",
  "Partners subscribed": "admin.ui.partners_subscribed",
  "partners.view, documents.verify, settings...": "admin.ui.partners_view_documents_verify_settings",
  "Passenger name": "admin.ui.passenger_name",
  "Passenger Name (if others)": "admin.ui.passenger_name_if_others",
  "Passenger name *": "admin.ui.passenger_name_2",
  "Passenger phone": "admin.ui.passenger_phone",
  "Passenger Phone (if others)": "admin.ui.passenger_phone_if_others",
  "Passenger phone *": "admin.ui.passenger_phone_2",
  "Password": "admin.ui.password",
  "Past food orders": "admin.ui.past_food_orders",
  "Past grocery orders": "admin.ui.past_grocery_orders",
  "Past Orders": "admin.ui.past_orders",
  "Pay": "admin.ui.pay",
  "Payee": "admin.ui.payee",
  "Payment": "admin.ui.payment",
  "Payment & SMS gateway config": "admin.ui.payment_sms_gateway_config",
  "Payment gateway global config": "admin.ui.payment_gateway_global_config",
  "Payment Methods": "admin.ui.payment_methods",
  "Payment methods, banks, payout cycles": "admin.ui.payment_methods_banks_payout_cycles",
  "Payment transactions": "admin.ui.payment_transactions",
  "Payment Type": "admin.ui.payment_type",
  "Payout": "admin.ui.payout",
  "Payout Cycles": "admin.ui.payout_cycles",
  "PayPal": "admin.ui.paypal",
  "Peak Hour": "admin.ui.peak_hour",
  "Peak hour bonus": "admin.ui.peak_hour_bonus",
  "Peak hour surge earnings": "admin.ui.peak_hour_surge_earnings",
  "Pending": "admin.ui.pending",
  "Pending Approval": "admin.ui.pending_approval",
  "Pending docs": "admin.ui.pending_docs",
  "Pending review": "admin.ui.pending_review",
  "People": "admin.ui.people",
  "Per ₹": "admin.ui.per",
  "Per Day": "admin.ui.per_day",
  "Per Hour": "admin.ui.per_hour",
  "Per Kg Rate": "admin.ui.per_kg_rate",
  "Per km": "admin.ui.per_km",
  "Per Km": "admin.ui.per_km_2",
  "Per Km Rate": "admin.ui.per_km_rate",
  "Per Min Rate": "admin.ui.per_min_rate",
  "Per Minute": "admin.ui.per_minute",
  "Per sqft": "admin.ui.per_sqft",
  "Per visit": "admin.ui.per_visit",
  "Per-restaurant addon groups used in the Food Add wizard and customer customization.": "admin.ui.per_restaurant_addon_groups_used_in_the_food_add_wizard_and_customer_customizati",
  "Per-service outcome comparison": "admin.ui.per_service_outcome_comparison",
  "Percentage": "admin.ui.percentage",
  "Percentage (%)": "admin.ui.percentage_2",
  "Performance badges & incentive tiers": "admin.ui.performance_badges_incentive_tiers",
  "Period": "admin.ui.period",
  "Period intelligence": "admin.ui.period_intelligence",
  "Permission Key": "admin.ui.permission_key",
  "Permissions": "admin.ui.permissions",
  "Permit Type": "admin.ui.permit_type",
  "Phone": "admin.ui.phone",
  "Phone *": "admin.ui.phone_2",
  "Phone number": "admin.ui.phone_number",
  "Phone Number": "admin.ui.phone_number_2",
  "PhonePe": "admin.ui.phonepe",
  "Picking & Packing": "admin.ui.picking_packing",
  "Picking Items": "admin.ui.picking_items",
  "Picking, packing, delivery workflow with stock-backed ordering.": "admin.ui.picking_packing_delivery_workflow_with_stock_backed_ordering",
  "Pickup": "admin.ui.pickup",
  "Pickup (A)": "admin.ui.pickup_a",
  "Pickup + Drop": "admin.ui.pickup_drop",
  "Pickup address": "admin.ui.pickup_address",
  "Pickup Address": "admin.ui.pickup_address_2",
  "Pickup Address *": "admin.ui.pickup_address_3",
  "Pickup branches for bike/car rental": "admin.ui.pickup_branches_for_bike_car_rental",
  "Pickup lat": "admin.ui.pickup_lat",
  "Pickup lng": "admin.ui.pickup_lng",
  "Pickup Location": "admin.ui.pickup_location",
  "Pickup OTP": "admin.ui.pickup_otp",
  "Pickup OTP (merchant) + Delivery OTP (customer)": "admin.ui.pickup_otp_merchant_delivery_otp_customer",
  "Pickup time": "admin.ui.pickup_time",
  "Pincode": "admin.ui.pincode",
  "Place Food Order": "admin.ui.place_food_order",
  "Place Grocery Order": "admin.ui.place_grocery_order",
  "Place Order": "admin.ui.place_order",
  "Plan": "admin.ui.plan",
  "Plan actions": "admin.ui.plan_actions",
  "Plan code": "admin.ui.plan_code",
  "Plan expiry": "admin.ui.plan_expiry",
  "Plan expiry (optional)": "admin.ui.plan_expiry_optional",
  "Plan features": "admin.ui.plan_features",
  "Plan highlights": "admin.ui.plan_highlights",
  "Plan highlights and visibility": "admin.ui.plan_highlights_and_visibility",
  "Plan info": "admin.ui.plan_info",
  "Plan name": "admin.ui.plan_name",
  "Plans": "admin.ui.plans",
  "Platform": "admin.ui.platform",
  "Platform Earnings": "admin.ui.platform_earnings",
  "Platform overview": "admin.ui.platform_overview",
  "Platform Service": "admin.ui.platform_service",
  "Platform services builder (add new services)": "admin.ui.platform_services_builder_add_new_services",
  "Platform-wide revenue reports": "admin.ui.platform_wide_revenue_reports",
  "Platinum": "admin.ui.platinum",
  "Play Store": "admin.ui.play_store",
  "Play Store · Android": "admin.ui.play_store_android",
  "Points": "admin.ui.points",
  "Popular": "admin.ui.popular",
  "Popular, Best value": "admin.ui.popular_best_value",
  "Porter": "admin.ui.porter",
  "Porter API Keys": "admin.ui.porter_api_keys",
  "Porter Categories": "admin.ui.porter_categories",
  "Porter Corporate Accounts": "admin.ui.porter_corporate_accounts",
  "Porter Order History": "admin.ui.porter_order_history",
  "Porter Packages": "admin.ui.porter_packages",
  "Porter parcel & goods delivery": "admin.ui.porter_parcel_goods_delivery",
  "Porter Pricing Rules": "admin.ui.porter_pricing_rules",
  "Porter Vehicles": "admin.ui.porter_vehicles",
  "Postal / PIN Code": "admin.ui.postal_pin_code",
  "Postpaid": "admin.ui.postpaid",
  "Prefer not to say": "admin.ui.prefer_not_to_say",
  "Preferred Language": "admin.ui.preferred_language",
  "Prefix": "admin.ui.prefix",
  "Premium": "admin.ui.premium",
  "Prepaid": "admin.ui.prepaid",
  "Preparation Time": "admin.ui.preparation_time",
  "Preparing": "admin.ui.preparing",
  "Prescription Templates": "admin.ui.prescription_templates",
  "Presets set End = Start + duration (DD/MM/YYYY). Custom: End must be after Start.": "admin.ui.presets_set_end_start_duration_dd_mm_yyyy_custom_end_must_be_after_start",
  "Press Enter to add": "admin.ui.press_enter_to_add",
  "Preview": "admin.ui.preview",
  "Price": "admin.ui.price",
  "Price (₹)": "admin.ui.price_2",
  "Price ₹": "admin.ui.price_3",
  "Price Per KM": "admin.ui.price_per_km",
  "Price Per Minute": "admin.ui.price_per_minute",
  "Price, billing cycle, trial, and caps": "admin.ui.price_billing_cycle_trial_and_caps",
  "Price, billing cycle, validity, and ride limits": "admin.ui.price_billing_cycle_validity_and_ride_limits",
  "Pricing": "admin.ui.pricing",
  "Pricing & limits": "admin.ui.pricing_limits",
  "Pricing & rules": "admin.ui.pricing_rules",
  "Pricing model": "admin.ui.pricing_model",
  "Pricing pending": "admin.ui.pricing_pending",
  "Pricing Rules": "admin.ui.pricing_rules_2",
  "Pricing set": "admin.ui.pricing_set",
  "Pricing support masters": "admin.ui.pricing_support_masters",
  "Pricing Templates": "admin.ui.pricing_templates",
  "Primary category": "admin.ui.primary_category",
  "Primary color": "admin.ui.primary_color",
  "Primary Color": "admin.ui.primary_color_2",
  "Primary display name — used when no translation exists for the user language": "admin.ui.primary_display_name_used_when_no_translation_exists_for_the_user_language",
  "Primary zone": "admin.ui.primary_zone",
  "Priority": "admin.ui.priority",
  "Privacy Policy": "admin.ui.privacy_policy",
  "Processing": "admin.ui.processing",
  "Product": "admin.ui.product",
  "Product Catalog": "admin.ui.product_catalog",
  "Product catalog — Grocery Add wizard with images": "admin.ui.product_catalog_grocery_add_wizard_with_images",
  "Product Catalog + Inventory": "admin.ui.product_catalog_inventory",
  "Product Image": "admin.ui.product_image",
  "Product Images": "admin.ui.product_images",
  "Product images and delivery windows": "admin.ui.product_images_and_delivery_windows",
  "Product Name": "admin.ui.product_name",
  "Product Variants": "admin.ui.product_variants",
  "Products & Inventory": "admin.ui.products_inventory",
  "Professional store profile — identity, location, compliance, timing, and revenue.": "admin.ui.professional_store_profile_identity_location_compliance_timing_and_revenue",
  "Profile": "admin.ui.profile",
  "Profile / vehicle update": "admin.ui.profile_vehicle_update",
  "Profile Photo": "admin.ui.profile_photo",
  "Profile update": "admin.ui.profile_update",
  "Promo": "admin.ui.promo",
  "Promo code": "admin.ui.promo_code",
  "Promo Code": "admin.ui.promo_code_2",
  "Promo codes + discount management": "admin.ui.promo_codes_discount_management",
  "Promo Codes + Discounts": "admin.ui.promo_codes_discounts",
  "Promo codes + loyalty configuration": "admin.ui.promo_codes_loyalty_configuration",
  "Promo codes + offers": "admin.ui.promo_codes_offers",
  "Promo Codes + Offers": "admin.ui.promo_codes_offers_2",
  "Promo Coupons": "admin.ui.promo_coupons",
  "Properties": "admin.ui.properties",
  "Protein (g)": "admin.ui.protein_g",
  "Provider": "admin.ui.provider",
  "Provider App": "admin.ui.provider_app",
  "Provider Earnings": "admin.ui.provider_earnings",
  "Providers": "admin.ui.providers",
  "Publish": "admin.ui.publish",
  "Publishable Key": "admin.ui.publishable_key",
  "Published date": "admin.ui.published_date",
  "Pure Veg": "admin.ui.pure_veg",
  "Push": "admin.ui.push",
  "Push setup": "admin.ui.push_setup",
  "Qty": "admin.ui.qty",
  "Quantity": "admin.ui.quantity",
  "Queue": "admin.ui.queue",
  "Quick access": "admin.ui.quick_access",
  "Quotation": "admin.ui.quotation",
  "Quotations": "admin.ui.quotations",
  "Quote #": "admin.ui.quote",
  "Quoted": "admin.ui.quoted",
  "Radius": "admin.ui.radius",
  "Rain": "admin.ui.rain",
  "Rank by": "admin.ui.rank_by",
  "Rate": "admin.ui.rate",
  "Rate & Review": "admin.ui.rate_review",
  "Rate Ride": "admin.ui.rate_ride",
  "Rating": "admin.ui.rating",
  "Razorpay": "admin.ui.razorpay",
  "Realtime": "admin.ui.realtime",
  "Reason": "admin.ui.reason",
  "Reason shown to the partner": "admin.ui.reason_shown_to_the_partner",
  "Receive Request": "admin.ui.receive_request",
  "Receiver name": "admin.ui.receiver_name",
  "Receiver phone": "admin.ui.receiver_phone",
  "Recent activity": "admin.ui.recent_activity",
  "Recommended": "admin.ui.recommended",
  "Redeem ₹/point": "admin.ui.redeem_point",
  "Redeem ₹/pt": "admin.ui.redeem_pt",
  "Reference": "admin.ui.reference",
  "Referral": "admin.ui.referral",
  "Referral code": "admin.ui.referral_code",
  "Referred user": "admin.ui.referred_user",
  "Refresh": "admin.ui.refresh",
  "Refresh balance": "admin.ui.refresh_balance",
  "Refund & cancellation policy": "admin.ui.refund_cancellation_policy",
  "Refund Policies": "admin.ui.refund_policies",
  "Registered": "admin.ui.registered",
  "Registered Email": "admin.ui.registered_email",
  "Registered Phone No": "admin.ui.registered_phone_no",
  "Reject": "admin.ui.reject",
  "Rejected": "admin.ui.rejected",
  "Rejection reason": "admin.ui.rejection_reason",
  "Rejection Reasons": "admin.ui.rejection_reasons",
  "Release notes": "admin.ui.release_notes",
  "Remaining Days": "admin.ui.remaining_days",
  "Remove": "admin.ui.remove",
  "Remove product?": "admin.ui.remove_product",
  "Remove restaurant?": "admin.ui.remove_restaurant",
  "Remove store?": "admin.ui.remove_store",
  "Rental": "admin.ui.rental",
  "Rental Management": "admin.ui.rental_management",
  "Rental package *": "admin.ui.rental_package",
  "Rental Package Management": "admin.ui.rental_package_management",
  "Rental Package Master": "admin.ui.rental_package_master",
  "Rental packages": "admin.ui.rental_packages",
  "Rental Packages": "admin.ui.rental_packages_2",
  "Reply": "admin.ui.reply",
  "Report": "admin.ui.report",
  "Report Builder": "admin.ui.report_builder",
  "Report Type": "admin.ui.report_type",
  "Reports": "admin.ui.reports",
  "Reports & settlements (if permitted)": "admin.ui.reports_settlements_if_permitted",
  "Request": "admin.ui.request",
  "Request # or trip id": "admin.ui.request_or_trip_id",
  "Request #, pickup, drop, customer, driver": "admin.ui.request_pickup_drop_customer_driver",
  "Request Number": "admin.ui.request_number",
  "Requested": "admin.ui.requested",
  "Required": "admin.ui.required",
  "Required for zone matching": "admin.ui.required_for_zone_matching",
  "Resolution notes": "admin.ui.resolution_notes",
  "Resolved": "admin.ui.resolved",
  "Resource": "admin.ui.resource",
  "Resource ID": "admin.ui.resource_id",
  "Restaurant": "admin.ui.restaurant",
  "Restaurant / Merchant": "admin.ui.restaurant_merchant",
  "Restaurant Addon Configuration": "admin.ui.restaurant_addon_configuration",
  "Restaurant analytics + order reports": "admin.ui.restaurant_analytics_order_reports",
  "Restaurant Catalog": "admin.ui.restaurant_catalog",
  "Restaurant Master": "admin.ui.restaurant_master",
  "Restaurant Name *": "admin.ui.restaurant_name",
  "Restaurant Onboarding + FSSAI": "admin.ui.restaurant_onboarding_fssai",
  "Restaurant onboarding + FSSAI verification": "admin.ui.restaurant_onboarding_fssai_verification",
  "Restaurant promo codes for your food store": "admin.ui.restaurant_promo_codes_for_your_food_store",
  "Restaurant Type": "admin.ui.restaurant_type",
  "Restaurants": "admin.ui.restaurants",
  "Retry": "admin.ui.retry",
  "Return date": "admin.ui.return_date",
  "Revenue": "admin.ui.revenue",
  "Revenue mix": "admin.ui.revenue_mix",
  "Revenue Model": "admin.ui.revenue_model",
  "Revenue today": "admin.ui.revenue_today",
  "Revenue trend (30 days)": "admin.ui.revenue_trend_30_days",
  "Revenue Updated": "admin.ui.revenue_updated",
  "Review": "admin.ui.review",
  "Review (optional)": "admin.ui.review_optional",
  "Review earnings & settlements": "admin.ui.review_earnings_settlements",
  "Review partner": "admin.ui.review_partner",
  "Reviewer": "admin.ui.reviewer",
  "Reviews": "admin.ui.reviews",
  "Ride #": "admin.ui.ride",
  "Ride Attribute": "admin.ui.ride_attribute",
  "Ride Category wizard is replaced by dynamic sub-service flow": "admin.ui.ride_category_wizard_is_replaced_by_dynamic_sub_service_flow",
  "Ride completed": "admin.ui.ride_completed",
  "Ride discount (%) (optional)": "admin.ui.ride_discount_optional",
  "Ride Images": "admin.ui.ride_images",
  "Ride Later": "admin.ui.ride_later",
  "Ride Later (Scheduled)": "admin.ui.ride_later_scheduled",
  "RIDE LATER Pricing": "admin.ui.ride_later_pricing",
  "Ride Now": "admin.ui.ride_now",
  "RIDE NOW Pricing": "admin.ui.ride_now_pricing",
  "Ride Overage ₹": "admin.ui.ride_overage",
  "Ride Tags": "admin.ui.ride_tags",
  "rideNumber, firstName": "admin.ui.ridenumber_firstname",
  "Riders": "admin.ui.riders",
  "Rides": "admin.ui.rides",
  "Rides Dashboard": "admin.ui.rides_dashboard",
  "Rides Included": "admin.ui.rides_included",
  "Rides Operations": "admin.ui.rides_operations",
  "Role": "admin.ui.role",
  "Role Name": "admin.ui.role_name",
  "Role-specific metrics and activity": "admin.ui.role_specific_metrics_and_activity",
  "Roles & Privileges": "admin.ui.roles_privileges",
  "Round off": "admin.ui.round_off",
  "Round Trip": "admin.ui.round_trip",
  "Route Group": "admin.ui.route_group",
  "Rule": "admin.ui.rule",
  "Rule name": "admin.ui.rule_name",
  "Rules": "admin.ui.rules",
  "Run live operations": "admin.ui.run_live_operations",
  "Running": "admin.ui.running",
  "S.No": "admin.ui.s_no",
  "SaaS tiers for tenants — pricing, limits, and plan highlights.": "admin.ui.saas_tiers_for_tenants_pricing_limits_and_plan_highlights",
  "Sales owner": "admin.ui.sales_owner",
  "Same as partner app vehicle / plate number": "admin.ui.same_as_partner_app_vehicle_plate_number",
  "Same name": "admin.ui.same_name",
  "Sandbox Mode": "admin.ui.sandbox_mode",
  "Saturday": "admin.ui.saturday",
  "Save": "admin.ui.save",
  "Save Profile": "admin.ui.save_profile",
  "Schedule": "admin.ui.schedule",
  "Schedule templates and image masters": "admin.ui.schedule_templates_and_image_masters",
  "Scheduled": "admin.ui.scheduled",
  "Scheduled At": "admin.ui.scheduled_at",
  "Scheduled At (for Ride Later)": "admin.ui.scheduled_at_for_ride_later",
  "Scheduled food orders": "admin.ui.scheduled_food_orders",
  "Scheduled Food Orders": "admin.ui.scheduled_food_orders_2",
  "Scheduled For": "admin.ui.scheduled_for",
  "Scheduled Orders": "admin.ui.scheduled_orders",
  "Scheduled Porter Orders": "admin.ui.scheduled_porter_orders",
  "Scheduled Time *": "admin.ui.scheduled_time",
  "Schedules and service images": "admin.ui.schedules_and_service_images",
  "Scope": "admin.ui.scope",
  "Search": "admin.ui.search",
  "Search by name or phone (min 3 chars)": "admin.ui.search_by_name_or_phone_min_3_chars",
  "Search company, slug, domain…": "admin.ui.search_company_slug_domain",
  "Search company, slug, email, owner…": "admin.ui.search_company_slug_email_owner",
  "Search customer": "admin.ui.search_customer",
  "Search customer (min 3 chars)": "admin.ui.search_customer_min_3_chars",
  "Search driver": "admin.ui.search_driver",
  "Search driver by name, phone, or vehicle number": "admin.ui.search_driver_by_name_phone_or_vehicle_number",
  "Search drivers…": "admin.ui.search_drivers",
  "Search earnings…": "admin.ui.search_earnings",
  "Search groups, codes, partner type, zones, or document names…": "admin.ui.search_groups_codes_partner_type_zones_or_document_names",
  "Search location": "admin.ui.search_location",
  "Search name or phone": "admin.ui.search_name_or_phone",
  "Search name, email, or phone…": "admin.ui.search_name_email_or_phone",
  "Search name, email, phone…": "admin.ui.search_name_email_phone",
  "Search primary or secondary zones…": "admin.ui.search_primary_or_secondary_zones",
  "Search privilege": "admin.ui.search_privilege",
  "Search records…": "admin.ui.search_records",
  "Search ref, customer, phone, address…": "admin.ui.search_ref_customer_phone_address",
  "Search reports…": "admin.ui.search_reports",
  "Search results…": "admin.ui.search_results",
  "Search services…": "admin.ui.search_services",
  "Search sub-categories…": "admin.ui.search_sub_categories",
  "Search templates": "admin.ui.search_templates",
  "Search tenants…": "admin.ui.search_tenants",
  "Search zones": "admin.ui.search_zones",
  "Search zones by name or code…": "admin.ui.search_zones_by_name_or_code",
  "Search zones...": "admin.ui.search_zones_2",
  "Search zones…": "admin.ui.search_zones_3",
  "Search, filter, and manage client accounts": "admin.ui.search_filter_and_manage_client_accounts",
  "Searching": "admin.ui.searching",
  "Secondary color": "admin.ui.secondary_color",
  "Secondary Color": "admin.ui.secondary_color_2",
  "Secret Key": "admin.ui.secret_key",
  "Seed": "admin.ui.seed",
  "Select a suggestion to auto-fill city, state, PIN, and country": "admin.ui.select_a_suggestion_to_auto_fill_city_state_pin_and_country",
  "Select a zone — configure pricing per vehicle and trip type (One Way / Round Trip).": "admin.ui.select_a_zone_configure_pricing_per_vehicle_and_trip_type_one_way_round_trip",
  "Select a zone to manage hour/km rental packages — same flow as Caby rental master.": "admin.ui.select_a_zone_to_manage_hour_km_rental_packages_same_flow_as_caby_rental_master",
  "Select item to add...": "admin.ui.select_item_to_add",
  "Select language": "admin.ui.select_language",
  "Select languages first": "admin.ui.select_languages_first",
  "Select languages…": "admin.ui.select_languages",
  "Select one or more": "admin.ui.select_one_or_more",
  "Select package": "admin.ui.select_package",
  "Select roles for dashboard access…": "admin.ui.select_roles_for_dashboard_access",
  "Select vehicle": "admin.ui.select_vehicle",
  "Semver e.g. 1.0.2": "admin.ui.semver_e_g_1_0_2",
  "Send welcome email with login details": "admin.ui.send_welcome_email_with_login_details",
  "Send welcome message (email and/or SMS when configured)": "admin.ui.send_welcome_message_email_and_or_sms_when_configured",
  "Sent": "admin.ui.sent",
  "Separate Modules (not in Food Add)": "admin.ui.separate_modules_not_in_food_add",
  "Service": "admin.ui.service",
  "Service (optional)": "admin.ui.service_optional",
  "Service / Vehicle": "admin.ui.service_vehicle",
  "Service Address": "admin.ui.service_address",
  "Service Catalog": "admin.ui.service_catalog",
  "Service Categories": "admin.ui.service_categories",
  "Service Code": "admin.ui.service_code",
  "Service configuration (enable / disable)": "admin.ui.service_configuration_enable_disable",
  "Service Engine": "admin.ui.service_engine",
  "Service hub": "admin.ui.service_hub",
  "Service Hub": "admin.ui.service_hub_2",
  "Service hub and operating zone for this user": "admin.ui.service_hub_and_operating_zone_for_this_user",
  "Service hubs": "admin.ui.service_hubs",
  "Service hubs — transport, delivery, on-demand": "admin.ui.service_hubs_transport_delivery_on_demand",
  "Service Masters Guide": "admin.ui.service_masters_guide",
  "Service Module": "admin.ui.service_module",
  "Service Name": "admin.ui.service_name",
  "Service name — English (EN)": "admin.ui.service_name_english_en",
  "Service provider": "admin.ui.service_provider",
  "Service Provider": "admin.ui.service_provider_2",
  "Service Providers": "admin.ui.service_providers",
  "Service radius (km)": "admin.ui.service_radius_km",
  "Service type": "admin.ui.service_type",
  "Service Type": "admin.ui.service_type_2",
  "Service volume vs completed": "admin.ui.service_volume_vs_completed",
  "Service-wise modules": "admin.ui.service_wise_modules",
  "Services": "admin.ui.services",
  "Services Setup Guide": "admin.ui.services_setup_guide",
  "Serving size": "admin.ui.serving_size",
  "Session Durations": "admin.ui.session_durations",
  "Session Rate": "admin.ui.session_rate",
  "Set active": "admin.ui.set_active",
  "Set driver commission % on zone": "admin.ui.set_driver_commission_on_zone",
  "Set driver commission % per zone": "admin.ui.set_driver_commission_per_zone",
  "Set Drop": "admin.ui.set_drop",
  "Set expired": "admin.ui.set_expired",
  "Set fare matrix (base, per km, per min, surge)": "admin.ui.set_fare_matrix_base_per_km_per_min_surge",
  "Set Location": "admin.ui.set_location",
  "Set Pickup": "admin.ui.set_pickup",
  "Set Prep Time": "admin.ui.set_prep_time",
  "Set zone fare matrix (base, per km, surge)": "admin.ui.set_zone_fare_matrix_base_per_km_surge",
  "Setting Categories (comma-separated)": "admin.ui.setting_categories_comma_separated",
  "Settings": "admin.ui.settings",
  "Settled": "admin.ui.settled",
  "Settlements": "admin.ui.settlements",
  "Settlements (Commission)": "admin.ui.settlements_commission",
  "Setup": "admin.ui.setup",
  "Share by service": "admin.ui.share_by_service",
  "Shared rejection reasons, delivery modes, address fields": "admin.ui.shared_rejection_reasons_delivery_modes_address_fields",
  "Short Description": "admin.ui.short_description",
  "Show all steps": "admin.ui.show_all_steps",
  "Show during driver mobile registration": "admin.ui.show_during_driver_mobile_registration",
  "Shown to drivers during mobile registration": "admin.ui.shown_to_drivers_during_mobile_registration",
  "Sign in & tenant context": "admin.ui.sign_in_tenant_context",
  "Silver": "admin.ui.silver",
  "Skills": "admin.ui.skills",
  "Skills (comma-separated codes)": "admin.ui.skills_comma_separated_codes",
  "Skills (masters)": "admin.ui.skills_masters",
  "Slot": "admin.ui.slot",
  "Slot date": "admin.ui.slot_date",
  "Slots, partner pricing, incentives, substitution": "admin.ui.slots_partner_pricing_incentives_substitution",
  "Slug": "admin.ui.slug",
  "Slug (optional)": "admin.ui.slug_optional",
  "Slug *": "admin.ui.slug_2",
  "Sodium (mg)": "admin.ui.sodium_mg",
  "Soft update message": "admin.ui.soft_update_message",
  "Sort order": "admin.ui.sort_order",
  "Sort Order": "admin.ui.sort_order_2",
  "SOS / Escalate": "admin.ui.sos_escalate",
  "SOS Command Center": "admin.ui.sos_command_center",
  "SOS Emergency Alerts": "admin.ui.sos_emergency_alerts",
  "SOS emergency button": "admin.ui.sos_emergency_button",
  "Source": "admin.ui.source",
  "Special handling": "admin.ui.special_handling",
  "Special handling surcharge JSON": "admin.ui.special_handling_surcharge_json",
  "Special Instructions": "admin.ui.special_instructions",
  "Specializations": "admin.ui.specializations",
  "Specific services": "admin.ui.specific_services",
  "Specific users / drivers": "admin.ui.specific_users_drivers",
  "Stacked revenue — transport, porter, and services": "admin.ui.stacked_revenue_transport_porter_and_services",
  "Staff roles, department, and permissions": "admin.ui.staff_roles_department_and_permissions",
  "Start date": "admin.ui.start_date",
  "Start Date": "admin.ui.start_date_2",
  "Start time": "admin.ui.start_time",
  "Start Trip": "admin.ui.start_trip",
  "Start typing — matching addresses from maps will appear below": "admin.ui.start_typing_matching_addresses_from_maps_will_appear_below",
  "Start typing to search addresses": "admin.ui.start_typing_to_search_addresses",
  "Started": "admin.ui.started",
  "Starts at": "admin.ui.starts_at",
  "Stat Card": "admin.ui.stat_card",
  "State": "admin.ui.state",
  "State / Region": "admin.ui.state_region",
  "State Required": "admin.ui.state_required",
  "Status": "admin.ui.status",
  "Stock": "admin.ui.stock",
  "Stock Alert Threshold": "admin.ui.stock_alert_threshold",
  "Stock Alerts": "admin.ui.stock_alerts",
  "Stops": "admin.ui.stops",
  "Store": "admin.ui.store",
  "Store analytics + order reports": "admin.ui.store_analytics_order_reports",
  "Store Analytics + Reports": "admin.ui.store_analytics_reports",
  "Store Catalog": "admin.ui.store_catalog",
  "Store Logo": "admin.ui.store_logo",
  "Store Master": "admin.ui.store_master",
  "Store master, types, categories": "admin.ui.store_master_types_categories",
  "Store Name": "admin.ui.store_name",
  "Store Onboarding + Verification": "admin.ui.store_onboarding_verification",
  "Store pickup": "admin.ui.store_pickup",
  "Store Type *": "admin.ui.store_type",
  "Store Types": "admin.ui.store_types",
  "Store URL": "admin.ui.store_url",
  "Stores": "admin.ui.stores",
  "Stores & Products": "admin.ui.stores_products",
  "Street": "admin.ui.street",
  "Street / Area": "admin.ui.street_area",
  "Street Address": "admin.ui.street_address",
  "Stripe": "admin.ui.stripe",
  "Sub Categories": "admin.ui.sub_categories",
  "Sub Category": "admin.ui.sub_category",
  "Sub-category": "admin.ui.sub_category_2",
  "Sub-Service": "admin.ui.sub_service",
  "Sub-Service Catalog": "admin.ui.sub_service_catalog",
  "Sub-Services": "admin.ui.sub_services",
  "Sub-Services moved to Transport Hub": "admin.ui.sub_services_moved_to_transport_hub",
  "Sub-services within enabled platform modules": "admin.ui.sub_services_within_enabled_platform_modules",
  "Sub-services within enabled platform modules â€” taxi, delivery, etc.": "admin.ui.sub_services_within_enabled_platform_modules_taxi_delivery_etc",
  "Subdomain": "admin.ui.subdomain",
  "Subject": "admin.ui.subject",
  "Submit": "admin.ui.submit",
  "Submitted": "admin.ui.submitted",
  "Subscription": "admin.ui.subscription",
  "Subscription based": "admin.ui.subscription_based",
  "Subscription plan": "admin.ui.subscription_plan",
  "Subscription Plan": "admin.ui.subscription_plan_2",
  "Subscription plan management": "admin.ui.subscription_plan_management",
  "Subscription plan menu": "admin.ui.subscription_plan_menu",
  "Subscription plans": "admin.ui.subscription_plans",
  "Subscriptions": "admin.ui.subscriptions",
  "Substitution + cancellation policy": "admin.ui.substitution_cancellation_policy",
  "Substitution Rules": "admin.ui.substitution_rules",
  "Subtract (-)": "admin.ui.subtract",
  "Subtract (−)": "admin.ui.subtract_2",
  "Sugar (g)": "admin.ui.sugar_g",
  "Summary": "admin.ui.summary",
  "Sunday": "admin.ui.sunday",
  "Super Admin": "admin.ui.super_admin",
  "Supplier": "admin.ui.supplier",
  "Suppliers": "admin.ui.suppliers",
  "Support": "admin.ui.support",
  "Support Number": "admin.ui.support_number",
  "Supported languages": "admin.ui.supported_languages",
  "Surge": "admin.ui.surge",
  "Surge delivery fee (peak hours)": "admin.ui.surge_delivery_fee_peak_hours",
  "Surge multiplier": "admin.ui.surge_multiplier",
  "Surge per km": "admin.ui.surge_per_km",
  "Suspend": "admin.ui.suspend",
  "Suspended": "admin.ui.suspended",
  "Swiggy-style restaurant profile — basic, business, compliance, timing, approval, and revenue model.": "admin.ui.swiggy_style_restaurant_profile_basic_business_compliance_timing_approval_and_re",
  "System": "admin.ui.system",
  "Takeaway": "admin.ui.takeaway",
  "Target": "admin.ui.target",
  "Target earnings (₹)": "admin.ui.target_earnings",
  "Target trips": "admin.ui.target_trips",
  "Tax code": "admin.ui.tax_code",
  "Tax Group": "admin.ui.tax_group",
  "Tax Groups": "admin.ui.tax_groups",
  "Tax Rules": "admin.ui.tax_rules",
  "Taxes": "admin.ui.taxes",
  "Taxi Drivers": "admin.ui.taxi_drivers",
  "Taxi rides, drivers, zones & masters": "admin.ui.taxi_rides_drivers_zones_masters",
  "Templates": "admin.ui.templates",
  "Tenant context": "admin.ui.tenant_context",
  "Tenant ID": "admin.ui.tenant_id",
  "Tenant Master": "admin.ui.tenant_master",
  "Tenant Services": "admin.ui.tenant_services",
  "Tenants": "admin.ui.tenants",
  "Theme / primary color": "admin.ui.theme_primary_color",
  "Theme Color": "admin.ui.theme_color",
  "This month": "admin.ui.this_month",
  "This Month": "admin.ui.this_month_2",
  "This week": "admin.ui.this_week",
  "This Week": "admin.ui.this_week_2",
  "Thumbnail Image": "admin.ui.thumbnail_image",
  "Thumbnail URL": "admin.ui.thumbnail_url",
  "Thursday": "admin.ui.thursday",
  "Ticket": "admin.ui.ticket",
  "Ticket #": "admin.ui.ticket_2",
  "Tier": "admin.ui.tier",
  "Time": "admin.ui.time",
  "Time slot": "admin.ui.time_slot",
  "Timeline": "admin.ui.timeline",
  "Timestamp": "admin.ui.timestamp",
  "Timezone": "admin.ui.timezone",
  "Timezones": "admin.ui.timezones",
  "Timing": "admin.ui.timing",
  "Title": "admin.ui.title",
  "To": "admin.ui.to",
  "To City": "admin.ui.to_city",
  "To date": "admin.ui.to_date",
  "To Date": "admin.ui.to_date_2",
  "Today": "admin.ui.today",
  "Toggle password": "admin.ui.toggle_password",
  "Toll": "admin.ui.toll",
  "Total": "admin.ui.total",
  "Total Amount": "admin.ui.total_amount",
  "Total Drivers": "admin.ui.total_drivers",
  "Total earnings": "admin.ui.total_earnings",
  "Total plans": "admin.ui.total_plans",
  "Total referred": "admin.ui.total_referred",
  "Total tenants": "admin.ui.total_tenants",
  "Trade License": "admin.ui.trade_license",
  "Transaction ID": "admin.ui.transaction_id",
  "Transactions": "admin.ui.transactions",
  "Translator Master": "admin.ui.translator_master",
  "Transmission": "admin.ui.transmission",
  "Transport": "admin.ui.transport",
  "Transport — End-to-End Flow": "admin.ui.transport_end_to_end_flow",
  "Transport (Local Taxi)": "admin.ui.transport_local_taxi",
  "Transport and delivery volume and revenue": "admin.ui.transport_and_delivery_volume_and_revenue",
  "Transport Hub": "admin.ui.transport_hub",
  "Transport hubs (POI)": "admin.ui.transport_hubs_poi",
  "Transport masters": "admin.ui.transport_masters",
  "Transport service": "admin.ui.transport_service",
  "Transport service masters": "admin.ui.transport_service_masters",
  "Transport Setup": "admin.ui.transport_setup",
  "Transport Sub-Services": "admin.ui.transport_sub_services",
  "Transport, porter, and services revenue, volume, and performance": "admin.ui.transport_porter_and_services_revenue_volume_and_performance",
  "Transportation": "admin.ui.transportation",
  "Trial": "admin.ui.trial",
  "Trial days": "admin.ui.trial_days",
  "Trial Days": "admin.ui.trial_days_2",
  "Trip": "admin.ui.trip",
  "Trip detail — fare, timeline, customer, and partner": "admin.ui.trip_detail_fare_timeline_customer_and_partner",
  "Trip ID": "admin.ui.trip_id",
  "Trip mode": "admin.ui.trip_mode",
  "Trip Mode": "admin.ui.trip_mode_2",
  "Trip target": "admin.ui.trip_target",
  "Trip type": "admin.ui.trip_type",
  "Trip Type": "admin.ui.trip_type_2",
  "Trip Type — OUTSTATION": "admin.ui.trip_type_outstation",
  "Trip Type — RENTAL": "admin.ui.trip_type_rental",
  "Trips": "admin.ui.trips",
  "Tuesday": "admin.ui.tuesday",
  "Twilio": "admin.ui.twilio",
  "Type": "admin.ui.type",
  "Type Key": "admin.ui.type_key",
  "Type name to searchâ€¦": "admin.ui.type_name_to_search",
  "Types": "admin.ui.types",
  "Types, specializations, and session rules": "admin.ui.types_specializations_and_session_rules",
  "Unassigned": "admin.ui.unassigned",
  "Unblock": "admin.ui.unblock",
  "Unified Dispatcher": "admin.ui.unified_dispatcher",
  "Unique slug (auto from name)": "admin.ui.unique_slug_auto_from_name",
  "Unit": "admin.ui.unit",
  "Unlimited": "admin.ui.unlimited",
  "Unverified": "admin.ui.unverified",
  "Upcoming orders scheduled for later delivery": "admin.ui.upcoming_orders_scheduled_for_later_delivery",
  "Upcoming scheduled restaurant orders": "admin.ui.upcoming_scheduled_restaurant_orders",
  "Update your name and contact details": "admin.ui.update_your_name_and_contact_details",
  "Updated": "admin.ui.updated",
  "Upload category icon/image": "admin.ui.upload_category_icon_image",
  "Upload package photo": "admin.ui.upload_package_photo",
  "Upload vehicle photo": "admin.ui.upload_vehicle_photo",
  "Uploaded": "admin.ui.uploaded",
  "Usage": "admin.ui.usage",
  "Usage Limit": "admin.ui.usage_limit",
  "Usage Today": "admin.ui.usage_today",
  "Use availability schedule": "admin.ui.use_availability_schedule",
  "Use current location": "admin.ui.use_current_location",
  "Use custom availability schedule": "admin.ui.use_custom_availability_schedule",
  "Use my current location": "admin.ui.use_my_current_location",
  "Use schedule": "admin.ui.use_schedule",
  "Use skill codes from Masters → Skills": "admin.ui.use_skill_codes_from_masters_skills",
  "Used": "admin.ui.used",
  "Used for product_images master lookup": "admin.ui.used_for_product_images_master_lookup",
  "Used when Firebase Admin SDK (v1) is not available on the server": "admin.ui.used_when_firebase_admin_sdk_v1_is_not_available_on_the_server",
  "User": "admin.ui.user",
  "User App": "admin.ui.user_app",
  "User growth (30 days)": "admin.ui.user_growth_30_days",
  "User ID": "admin.ui.user_id",
  "User management (customers + partners)": "admin.ui.user_management_customers_partners",
  "User Type": "admin.ui.user_type",
  "Users": "admin.ui.users",
  "Users & Admins": "admin.ui.users_admins",
  "Utilization": "admin.ui.utilization",
  "Valid until": "admin.ui.valid_until",
  "Validity": "admin.ui.validity",
  "Validity (days)": "admin.ui.validity_days",
  "Value": "admin.ui.value",
  "VAPID private key": "admin.ui.vapid_private_key",
  "VAPID public key": "admin.ui.vapid_public_key",
  "VAPID subject": "admin.ui.vapid_subject",
  "Variables": "admin.ui.variables",
  "Variant": "admin.ui.variant",
  "Variant Name": "admin.ui.variant_name",
  "Variant Templates": "admin.ui.variant_templates",
  "Variants": "admin.ui.variants",
  "Veg": "admin.ui.veg",
  "Vehicle": "admin.ui.vehicle",
  "Vehicle Brand": "admin.ui.vehicle_brand",
  "Vehicle Color": "admin.ui.vehicle_color",
  "Vehicle Documents": "admin.ui.vehicle_documents",
  "Vehicle fleet hierarchy": "admin.ui.vehicle_fleet_hierarchy",
  "Vehicle Fleet Masters": "admin.ui.vehicle_fleet_masters",
  "Vehicle image": "admin.ui.vehicle_image",
  "Vehicle Model": "admin.ui.vehicle_model",
  "Vehicle name": "admin.ui.vehicle_name",
  "Vehicle Name": "admin.ui.vehicle_name_2",
  "Vehicle number": "admin.ui.vehicle_number",
  "Vehicle Type": "admin.ui.vehicle_type",
  "Vehicle type *": "admin.ui.vehicle_type_2",
  "Vehicle Types": "admin.ui.vehicle_types",
  "Vehicle types with OUTSTATION service type": "admin.ui.vehicle_types_with_outstation_service_type",
  "Vehicle types with RENTAL service type": "admin.ui.vehicle_types_with_rental_service_type",
  "Vehicle Variant": "admin.ui.vehicle_variant",
  "Vehicles": "admin.ui.vehicles",
  "Vendor": "admin.ui.vendor",
  "Vendor App": "admin.ui.vendor_app",
  "Vendor Email": "admin.ui.vendor_email",
  "Vendor Hub": "admin.ui.vendor_hub",
  "Vendor Login URL": "admin.ui.vendor_login_url",
  "Vendor Password": "admin.ui.vendor_password",
  "Venue": "admin.ui.venue",
  "Venues": "admin.ui.venues",
  "Venues, organizers, and cancellation policies.": "admin.ui.venues_organizers_and_cancellation_policies",
  "Verification code": "admin.ui.verification_code",
  "Verification Status": "admin.ui.verification_status",
  "Verified": "admin.ui.verified",
  "Verify": "admin.ui.verify",
  "Verify uploaded documents and approve onboarding": "admin.ui.verify_uploaded_documents_and_approve_onboarding",
  "Verify uploaded documents and approve the driver for the app": "admin.ui.verify_uploaded_documents_and_approve_the_driver_for_the_app",
  "Verify with": "admin.ui.verify_with",
  "Version": "admin.ui.version",
  "Video": "admin.ui.video",
  "Video Consultation Setup Guide": "admin.ui.video_consultation_setup_guide",
  "View": "admin.ui.view",
  "View all in Partners": "admin.ui.view_all_in_partners",
  "View all notifications": "admin.ui.view_all_notifications",
  "View document": "admin.ui.view_document",
  "View documents": "admin.ui.view_documents",
  "View Drivers": "admin.ui.view_drivers",
  "View Menu": "admin.ui.view_menu",
  "View packages": "admin.ui.view_packages",
  "View Products": "admin.ui.view_products",
  "View service": "admin.ui.view_service",
  "View Sub-Service List": "admin.ui.view_sub_service_list",
  "View subscribed partners": "admin.ui.view_subscribed_partners",
  "View trip details & map": "admin.ui.view_trip_details_map",
  "View, approve, and manage transport drivers — online status, trips, and documents.": "admin.ui.view_approve_and_manage_transport_drivers_online_status_trips_and_documents",
  "Visit charge": "admin.ui.visit_charge",
  "Visit charge master": "admin.ui.visit_charge_master",
  "Visit Charges": "admin.ui.visit_charges",
  "Volume and completion by service · Click a bar to view orders": "admin.ui.volume_and_completion_by_service_click_a_bar_to_view_orders",
  "Waiting Charge / min": "admin.ui.waiting_charge_min",
  "Waive per-ride commission while active": "admin.ui.waive_per_ride_commission_while_active",
  "Wallet": "admin.ui.wallet",
  "Wallet + direct bank settlement": "admin.ui.wallet_direct_bank_settlement",
  "Wallet Balance": "admin.ui.wallet_balance",
  "Wallet frozen": "admin.ui.wallet_frozen",
  "Warehouse": "admin.ui.warehouse",
  "Warehouse + supplier masters": "admin.ui.warehouse_supplier_masters",
  "Warehouses": "admin.ui.warehouses",
  "Web admin password — employee and admin only": "admin.ui.web_admin_password_employee_and_admin_only",
  "Webhook Secret": "admin.ui.webhook_secret",
  "Wednesday": "admin.ui.wednesday",
  "Weekly": "admin.ui.weekly",
  "Weekly Holiday": "admin.ui.weekly_holiday",
  "Weight (kg)": "admin.ui.weight_kg",
  "Weight Type": "admin.ui.weight_type",
  "Weight Types": "admin.ui.weight_types",
  "What each service tab shows and key actions. Click a row to open that tab.": "admin.ui.what_each_service_tab_shows_and_key_actions_click_a_row_to_open_that_tab",
  "What each tab does in the Services hub.": "admin.ui.what_each_tab_does_in_the_services_hub",
  "What this plan is for — shown when creating a tenant": "admin.ui.what_this_plan_is_for_shown_when_creating_a_tenant",
  "When · For whom": "admin.ui.when_for_whom",
  "When outstation bookings are accepted": "admin.ui.when_outstation_bookings_are_accepted",
  "Which date From/To use": "admin.ui.which_date_from_to_use",
  "Whole numbers from 1 to 50": "admin.ui.whole_numbers_from_1_to_50",
  "Window expired": "admin.ui.window_expired",
  "Workflows & dynamic forms": "admin.ui.workflows_dynamic_forms",
  "Working Calendars": "admin.ui.working_calendars",
  "Working Hours": "admin.ui.working_hours",
  "XXXXX": "admin.ui.xxxxx",
  "Yearly": "admin.ui.yearly",
  "Yesterday": "admin.ui.yesterday",
  "You": "admin.ui.you",
  "Your promos": "admin.ui.your_promos",
  "Zone": "admin.ui.zone",
  "Zone & Hub": "admin.ui.zone_hub",
  "Zone code": "admin.ui.zone_code",
  "Zone Commission": "admin.ui.zone_commission",
  "Zone commission % deducted": "admin.ui.zone_commission_deducted",
  "Zone detected at pickup": "admin.ui.zone_detected_at_pickup",
  "Zone Fare Quote": "admin.ui.zone_fare_quote",
  "Zone level": "admin.ui.zone_level",
  "Zone Management": "admin.ui.zone_management",
  "Zone Management (external)": "admin.ui.zone_management_external",
  "Zone name": "admin.ui.zone_name",
  "Zone Pricing": "admin.ui.zone_pricing",
  "Zone setup with polygon + fare matrix": "admin.ui.zone_setup_with_polygon_fare_matrix",
  "Zone-based calculation": "admin.ui.zone_based_calculation",
  "Zone-Based Driver Earnings": "admin.ui.zone_based_driver_earnings",
  "Zone-wise scope": "admin.ui.zone_wise_scope",
  "Zones": "admin.ui.zones",
  "Zones & Coverage": "admin.ui.zones_coverage",
  "Zones & pricing (view / edit if permitted)": "admin.ui.zones_pricing_view_edit_if_permitted",
  "Zones + Fare Matrix": "admin.ui.zones_fare_matrix",
  "Zones + Partner Pricing": "admin.ui.zones_partner_pricing",
  "Zones + Partner Pricing + Incentives": "admin.ui.zones_partner_pricing_incentives",
  "Zones + partner pricing + incentives → grocery masters → Grocery Add → slots & dispatch.": "admin.ui.zones_partner_pricing_incentives_grocery_masters_grocery_add_slots_dispatch"
};
